import React, {useState, useEffect, useContext, useRef} from 'react'
import Header from "../components/header/Header";
import '../components/css/program.css'
import { useNavigate } from "react-router-dom";
import edit from '../images/edit.png'
import GroupEditModal from '../components/Modals/GroupEditModal';
import { DayPicker  } from 'react-day-picker';
import da from "date-fns/locale/da";
import close from '../images/close.png'
import searchIcon from '../images/search-26233.png'
import calendar from '../images/Icon-Calendar.png'
import { keyContext } from "../components/KeyContext";
import FilmWidget from '../components/FilmWidgets'
import trans from '../images/trans.png'
import doublearrow from '../images/double-arrow.png'
import moment from 'moment'
import small_square from '../images/small_square.svg'
import small_checkmark from '../images/small_checkmark.svg'
import alertIcon from '../images/Icon-Altert_Small.png'
import iconCross from '../images/Icon-Cross.png'
import { format, addMinutes, } from 'date-fns'
import DatePickerStart from '../components/DatePickerStart/DatePickerStart';
import DatePickerEnd from '../components/DatePickerEnd/DatePickerEnd';
import ScaleLoader  from 'react-spinners/ScaleLoader';
import OrgSelect from '../components/OrgSelect';
import WaitingModal from '../components/Modals/WaitingModal';
import semiCheckbox from '../images/Semi-checked.svg';
import NoteModal from '../components/Modals/NoteModal';
import EditChosenBox from '../components/Modals/EditChosenBox';
import ErrorModal from '../components/Modals/ErrorModal';
import ManEventErrorModal from '../components/Modals/ManEventErrorModal';
import greenCheck from '../images/checkmark-green.png'
import redCheck from '../images/checkmark-red.png'
import PushEventModal from '../components/Modals/PushEventModal';
import ProgramTable from '../components/ProgramTable';
import downArrow from '../images/down-arrow.png';
import checkmark from '../images/checkmark.png';

function Program() {
              
const { setSelectAllFilmAtOnce, selectedStartDate, selectedEndDate,setLeftMargin, setArrTypes ,  allTicketTypes, setAllTicketTypes,     modalOpen ,moviesSelected,setMoviesSelected ,    selectAllFilmAtOnce,deletebtnclk, setDeletebtnclk, dateChosen, anyMovieSelected,setAnyMovieSelected, divOpened,allOne,allzero,savebtnclk, setSavebtnclk, setalertEvents,eventEdit,eventsChanged , eventSaveObj, setEventSaveObj,showErrorModal,errorNo, errorText,    setShowErrorModal, setErrorNo, setErrorText, showFilm, setShowFilm, showDropdown, setShowDropdown, clickedMovieDiv, waitingModal, setWaitingModal,errorStatus,errorType,setErrorStatus,setErrorType,setApiLoader,apiLoader,  pushModal, setPushModal,logOut,changes,changesLeft,setChangesLeft,eventPushCheck,setProgrammedDates,setEventErrorModal,eventErrorModal,setAll_events_edit,manEventErrortext, setManEventErrortext,setDraggedMovieId, draggedFilm, setDraggedFilm,showG,setShowG,call_get_program,} = useContext(keyContext)

  let flag = false // flag determines overlap text when api takes more than 2 seconds to reply
  const windowHeight = window.innerHeight  
  const [dragging, setdragging] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const key = sessionStorage.getItem("key");  
  const allowOverlap = localStorage.getItem('allow_overlap')
  const [isloading, setIsLoading] = useState(true);
  const [preciseFilm, setPreciseFilm] = useState();
  const [searchPrecise, setSearchPrecise] = useState(false);
  const [searchOwnOnly, setSearchOwnOnly] = useState(false)

  const [divOverlap, setDivOverlap] = useState(false);
  const navigate = useNavigate();
  const [zeroPriceError, setZeroPriceError] = useState();
  const [groupStaffInfoShown,setGroupStaffInfoShown]    = useState(false)
  const [groupWebInfoShown,setGroupWebInfoShown]        = useState(false)
  const [groupStaffText,setGroupStaffText]              = useState('')
  const [groupWebText, setGroupWebText]                 = useState('');
  const [ groupStaffTextInput, setGroupStaffTextInput ] = useState('')
  const [groupWebTextInput, setGroupWebTextInput]       = useState('');
  const [commitModal, setCommitModal] = useState(false);
  const [groupstaffInfoSaved, setGroupStaffInfoSaved] = useState(false);
  const [groupwebInfoSaved, setGroupWebInfoSaved] = useState(false);
  const [allStaffTextInput, setAllStaffTextInput ] = useState('')
  const [allWebTextInput, setAllWebTextInput]       = useState('');
  const [staffInfoSaved, setStaffInfoSaved] = useState(false);
  const [webInfoSaved, setWebInfoSaved] = useState(false);
  // const [manEventErrortext, setManEventErrortext] = useState();
    let default_filmID = sessionStorage.getItem('default-filmID')



 const [chosenMovies, setchosenMovies] = useState([]);


 const [number_of_days, setNumber_of_days] = useState(); // chosen number of days



function getDatesBetween(startDate, endDate) {
  const dates = [];
  let currentDate = moment(startDate);
  const lastDate = moment(endDate);

  while (currentDate.isSameOrBefore(lastDate)) {
    dates.push(currentDate.format('YYYY-MM-DD')); // or currentDate.clone()
    currentDate.add(1, 'days');
  }

  return dates;
}

const dates_array = getDatesBetween(moment(selectedStartDate).format('YYYY-MM-DD'), moment(selectedEndDate).format('YYYY-MM-DD'))

 useEffect(() => {
  setNumber_of_days(dates_array.length)
 }, [selectedStartDate,selectedEndDate]);

const getNextDays = () => {
  return Array.from({ length: number_of_days }, (_, i) => {
    const date = new Date(selectedStartDate);
    date.setDate(date.getDate() + i);
    return date;
  });
};

useEffect(() => {
  setchosenMovies([])
}, [selectedStartDate]);

 const number_of_days_array = getNextDays();

  // const divHeight = document.getElementById('tes').getBoundingClientRect().height
  function handlePreciseSearch () {
    setSearchPrecise((current) => !current)
  }
  function handleOwnSearchOnly () {
    setSearchOwnOnly((current) => !current)
  }

 let ge = sessionStorage.getItem('programOrg')

 let orgSelect = ge && ge.split(" ")[ge.split(" ").length - 1]

  useEffect(() => {
    document.title = "Programlægning - ebillet_admin";
   
  }, []);


  //----------preventing body scroll when modal is open------------- 
  if(modalOpen === true) {
    document.body.style.overflowY = 'hidden'
  } else document.body.style.overflowY= ''

  const override: CSSProperties = {
    display: "block",
    position: "absolute",
    top: "30%",
    left: "50%",
    margin: "0 auto",
    textAlign: "center",
    borderColor: "#982f2f",
    transform: "translate(-50%, -50%)",
  };

  const disabledDays = [{ from: new Date(2022, 0, 1), to:  moment().subtract(1, 'day').toDate() }] ;
  const [modalShown, toggleModal] = useState(false);
  const [overlapModal, setOverlapModal] = useState(false)
 

  const [showTime,setShowTime] = useState(false)


  const [error,setError] = useState(false)
  const [grpEditArr, setGrpEditArr] = useState([])

  const [filmWidth, setFilmWidth] = useState()

  const [editChosen, setEditChosen] = useState(false)
  const [copyChosen, setCopyChosen] = useState(false)
  const [original_events, setOriginal_events] = useState([]);


  const [saveFilmEdit, setSaveFilmEdit] = useState(false);
  const [newDraggedFilm, setNewDraggedFilm] = useState()
 

  const [startDatoCal,setStartDatoCal] = useState(false)
  const [endDatoCal,setEndDatoCal] = useState(false) 
 
  const [startDate,setStartDate] = useState(new Date()) 
  const [endDate, setEndDate] = useState('') 
  let start_dato = moment(startDate).format('DD-MM-YYYY')
  let end_dato =  endDate ?   moment(endDate).format('DD-MM-YYYY') : 'Tilføj dato(er)'
 
  const [month, setMonth] = useState(); 



useEffect(() => {
  setStartDate(selectedStartDate)
},[selectedStartDate])

useEffect(() => {
  setMonth(selectedStartDate)
},[selectedStartDate])


function asFirstDate() {
  setEndDate(startDate)
  setEndDatoCal(false)
}

//------ the value from search input
  const [q, setQ] = useState("");

  const [allMovies, setAllMovies]     = useState([]);
  const [numberOfSal, setnumberOfSal] = useState([]);
  const [allEvents, setAllEvents]     = useState([]);
  const [eventsEdit, setEventsEdit]   = useState([])
  const [filmSearch, setFilmSearch ]  = useState([])
  const [copied, setCopied]           = useState(false);
  //----- events variables declarations --------------

  const [eventDelete, setEventDelete] = useState(false);

  //----------api call for data----------- getProgram call
  useEffect(() => {
    if(orgSelect || default_filmID) { 
      setIsLoading(true)
      setError(false)
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${default_filmID ? default_filmID : orgSelect}`;
    if(key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
     .then(res =>  {
   
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => {
        
             setIsLoading(false)

       
              if(result?.Message) {
                setError(true)
              }
                else {
             
        setAllMovies(result.Movies)
        setnumberOfSal(result.Locations)
        setAllEvents(result.Events)
        setOriginal_events(result.Events)
        setEventsEdit(result.EventsEdit && result.EventsEdit)
       // setFilmSearch(result.Movies)
        setAllTicketTypes(result.TicketTypes)
        setArrTypes(result.ArrTypes)
        
        setError(false)
      }
   
      })
       
    }
  }
  }, [key,orgSelect,dateChosen,setArrTypes, setAllTicketTypes,copied,deletebtnclk,savebtnclk,eventDelete,number_of_days])
  
 

    useEffect(() => {
         let dd = []
         allEvents.map((e) =>  { 
            dd.push(moment(e.start).format('YYYY-MM-DD'))    
        })
       setProgrammedDates(dd) 
   },[allEvents, setProgrammedDates]);


    useEffect(() => {
         let dd = []
         eventsEdit.map((e) =>  { 
            dd.push(moment(e.start).format('YYYY-MM-DD'))    
         })
         
     setAll_events_edit(dd) 
   },[eventsEdit, setAll_events_edit,selectedStartDate]);

   
//------ api call for movie search ------------man_movie_search
 useEffect(() => {
  const endpoint1 = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${'%25'+q+'%25'}`;
  const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${q}`;

    if(key && q && searchOwnOnly === false) {
 
      fetch(searchPrecise === true ? endpoint : endpoint1, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
      .then(res =>  { 
    
        if(res.status === 200) {
          return  res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 
           
         
              if(result) { 
                  // q.length && 
                   setFilmSearch( toFindDuplicates(result))
              }
              else {
                 setShowErrorModal(true)
                 setErrorNo(result.Result)
                 setErrorText(result.ErrorDescription)
              }
         
      
        
      })
     
    }
 },[key,q,searchPrecise,searchOwnOnly])


  const [aclicked,setAclicked] = useState(false) 
  const [bclicked,setBclicked] = useState(false)
  const [cclicked,setCclicked] = useState(false)
  const [dclicked,setDclicked] = useState(false)
  const [eclicked,setEclicked] = useState(false)
  const [a2clicked,setA2clicked] = useState(false) 
  const [b2clicked,setB2clicked] = useState(false)
  const [c2clicked,setC2clicked] = useState(false)
  const [d2clicked,setD2clicked] = useState(false)
  const [e2clicked,setE2clicked] = useState(false)
  const [numberedClicked, setNumberedClicked] = useState(false);
  const [numbered2Clicked, setNumbered2Clicked] = useState(false);

 const [internetorderflag, setInternetorderflag] = useState()
 const [internetsellflag,   setInternetsellflag] = useState()
 const [intershowflag,         setIntershowflag] = useState()
 const [sellticketflag,       setSellticketflag] = useState()
 const [orderticketflag,     setOrderticketflag] = useState()
 const [numberedSeatflag, setNumberedSeatflag] = useState();
 const [allPriceGrpsame, setAllPriceGrpsame] = useState(false);
 const [allForstypeSame, setAllForstypeSame] = useState(false);
 const [allTicketTypeSame, setAllTicketTypeSame] = useState(false);
 const [allBilletNotesSame, setAllBilletNotesSame] = useState(false);
 const [allWebNotesSame, setAllWebNotesSame] = useState(false);


const sameObject = (a, b) => {
  if (a.length !== b.length) return false;

  return a.every((obj, i) =>
    obj.No === b[i].No &&
    obj.Name === b[i].Name &&
    obj.Price === b[i].Price
  );
};

const allSame = (data) =>
  data.every(arr => sameObject(arr, data[0]));

useEffect(() => {
  let arr_web_res =[]   // web reserveinfo
  let arr_web_buy =[]   // web buyinfo
  let arr_web_show=[]  // web show info
  let arr_buy=[]       // buy enabled
  let arr_res=[]       // res enabled
  let price_groups=[]  // price groups
  let arrtype_names=[] // arr type name
  let unnumbered_tickets = [] // unnumbered tickets
  let ticket_types=[]  // ticket types
  let billetpro_notes = [] // notes i billetPro
  let webside_notes = []

  for (let index = 0; index < grpEditArr.length; index++) {
         arr_web_res.push(grpEditArr[index].webReserveInfo  )
         arr_web_buy.push(grpEditArr[index].eventObject.WebbuyInfo.enabled  )
         arr_web_show.push(grpEditArr[index].webshowInfo)
         arr_buy.push(grpEditArr[index].buyEnabled)
         arr_res.push(grpEditArr[index].reserveEnabled )
         unnumbered_tickets.push(grpEditArr[index].numberedSeats)
         price_groups.push(grpEditArr[index].priceGroups)
         arrtype_names.push(grpEditArr[index].ArrTypeName )
         ticket_types.push(grpEditArr[index].eventObject.TicketTypes)
         billetpro_notes.push(grpEditArr[index].eventObject.StaffInfo)
         webside_notes.push(grpEditArr[index].eventObject.WebInfo)
    }

    setAllTicketTypeSame(allSame(ticket_types))
  
    setAllWebNotesSame(webside_notes.every(value => value === webside_notes[0]))
  
    setAllBilletNotesSame(billetpro_notes.every(value => value === billetpro_notes[0]  ))
  
    setAllForstypeSame(arrtype_names.every(value => value === arrtype_names[0]))
  
    setAllPriceGrpsame(allSame(price_groups))

    setNumberedSeatflag(unnumbered_tickets.every(val => val === true) ? 1 :unnumbered_tickets.every(val => val === false) ? 0 : 2)

    setInternetorderflag(arr_web_res.every((no) => no === 1) === true ? 1 : arr_web_res.every((no) => no === 0) === true ? 0 : 2 )

    setInternetsellflag(arr_web_buy.every((no) => no === 1) === true ? 1 : arr_web_buy.every((no) => no === 0) === true ? 0 : 2 )

    setIntershowflag(arr_web_show.every((no) => no === 1) === true ? 1 : arr_web_show.every((no) => no === 0) === true ? 0 : 2 )

    setSellticketflag(arr_buy.every((no) => no === 1) === true ? 1 : arr_buy.every((no) => no === 0) === true ? 0 : 2 )

    setOrderticketflag(arr_res.every((no) => no === 1) === true ? 1 : arr_res.every((no) => no === 0) === true ? 0 : 2 )

}, [grpEditArr]);


// INTERNT BESTILLING
const [interorderChanged, setInterorderChanged] = useState();
const [interorderClicked2, setInterorderClicked2] = useState(false);
const [interOrder, setInterOrder] = useState(false);
const [interOrder2, setInterOrder2] = useState(2);



// INTERNET ORDER
useEffect(() => {
  setInterOrder(internetorderflag === 1 ? true : false)
 }, [internetorderflag]);


  const handleInternetOrder = () => {  
    setInterOrder((current) => !current)
    setInterorderChanged((current) => !current)
    setAclicked(true) 
  }
 
function  handleInternetOrder2(){
  setInterOrder2((interOrder2+1)%3)
  setA2clicked(true)
}

useEffect(() => {
  if(interOrder2 == 0  || interOrder2 == 1){
    setInterorderChanged(true)
  }
  else setInterorderChanged(false)
}, [interOrder2]);


// NUMBERED SEAT
const [numberedSeat, setNumberedSeat] = useState(false);
const [numberedSeat2, setNumberedSeat2] = useState(2);
const [numberedSeatChanged, setNumberedSeatChanged] = useState();
useEffect(() => {
  setNumberedSeat(numberedSeatflag === 1 ? true : false)
}, [numberedSeatflag]);

function handleNumeredSeatflag () {
    setNumberedSeat((current) => !current)
    setNumberedSeatChanged((current) => !current)
    setNumberedClicked(true)
} 
function handleNumeredSeatflag2 () {
    setNumberedSeat2((numberedSeat2+1)%3)
    setNumbered2Clicked(true)
}
useEffect(() => {
  if(numberedSeat2 == 0  || numberedSeat2 == 1){
    setNumberedSeatChanged(true)
  }
  else setInterorderChanged(false)
}, [numberedSeat2]);

// INTERNET SALG
const [intersalgChanged, setIntersalgChanged] = useState(false);
const [intersalgClicked2, setIntersalgClicked2] = useState(false);
const [interSalg, setInterSalg] = useState(false);
const [interSalg2, setInterSalg2] = useState(2);

useEffect(() => {
 setInterSalg(internetsellflag === 1 ? true : false)
}, [internetsellflag]);

const handleInternetSell = () => {
  setInterSalg((current) => !current)
  setIntersalgChanged((current) => !current)
  setBclicked(true)
 }
 function  handleInternetSell2(){
  setInterSalg2((interSalg2+1)%3)
  // setIntersalgClicked2(true)
  setB2clicked(true)
 }

useEffect(() => {
  if(interSalg2 == 0 || interSalg2 == 1) {
    setIntersalgChanged(true )
  }
  else {
    setIntersalgChanged(false)
  }
}, [interSalg2]);

 //INTERNET VISNING
const [intershowChanged, setIntershowChanged] = useState(false);
const [intershowClicked2, setIntershowClicked2] = useState(false);
const [interShow, setInterShow] = useState(false);
const [interShow2, setInterShow2] = useState(2);

useEffect(() => {
  setInterShow(intershowflag === 1 ? true : false)
}, [intershowflag]);


 const handleInternetShow = () => {
  setInterShow((current) => !current)
 setIntershowChanged((current) => !current)
 setCclicked(true)

 }
function handleInternetShow2(){
  setInterShow2((interShow2+1)%3)
  setC2clicked(true)
// setIntershowClicked2(true)
}

useEffect(() => {
  if(interShow2 === 0 || interShow2 === 1) {
    setIntershowChanged(true)
  }
  else 
    setIntershowChanged(false)  
}, [interShow2]);

// BUY ENABLED
const [buyChanged,  setBuyChanged] = useState(false);
const [buyClicked2, setBuyClicked2] = useState(false);
const [buyEnabled,  setBuyEnabled] = useState(false);
const [buyEnabled2, setBuyEnabled2] = useState(2);


useEffect(() => {
  setBuyEnabled(sellticketflag === 1 ? true : false)
}, [sellticketflag]);

const handleTicketSell = () => {
  setBuyEnabled((current) => !current)
  setBuyChanged((current) => !current)
  setDclicked(true)

 }

function handleTicketSell2(){
  setBuyEnabled2((buyEnabled2+1)%3)
  setD2clicked(true)
// setBuyClicked2(true)
}

useEffect(() => {
  if(buyEnabled2 === 0 || buyEnabled2 === 1) {
    setBuyChanged(true)
  }
  else   setBuyChanged(false)

}, [buyEnabled2]);

// RESERVE ENABLED
const [resChanged,  setResChanged] = useState(false);
const [resClicked2, setResClicked2] = useState(false);
const [resEnabled,  setResEnabled] = useState(false);
const [resEnabled2, setResEnabled2] = useState(2);

useEffect(() => {
  setResEnabled(orderticketflag === 1 ? true : false)
}, [orderticketflag]);

const handleTicketSellOrder = () => {
 
  setResEnabled((current) => !current)
  setResChanged((current) => ! current)
  setEclicked(true)
 }
 function  handleTicketSellOrder2(){
  setResEnabled2((resEnabled2+1)%3)
  setE2clicked(true)
  // setResClicked2(true)
 }
 useEffect(() => {
  if(resEnabled2 === 0 || resEnabled2 === 1) {
    setResChanged(true)
  }
  else   setResChanged(false)

 }, [resEnabled2]);

 

  // ----search functionality------
  const [searchParam] = useState(["name"]);
  const [filterParam, setFilterParam] = useState(["name"]);
 
   function toFindDuplicates(arr) {
    const uniqueElements = new Set(arr);
    // const filteredElements =
    arr.filter((item) => {
      if (uniqueElements.has(item)) {
        // uniqueElements.delete(item);
      } else {
        return item;
      }
    });

    return [...new Set(uniqueElements)];
  }
  const data = Object.values(filmSearch?.length ? filmSearch : toFindDuplicates(allMovies) )
 

  function search(items) {
      let events = searchOwnOnly === true ? allMovies : items
    return events.filter((item) => {
     
        if (filterParam == "name") {
            return searchParam.some((newItem) => {
                return (
                  item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        }
    });
   
  
  }

  // EVENT SAVE API CALL 
  async function eventSave(ev) {
      ev.AllowOverlap = 1
      ev.TicketTypes_Add = ev.TicketTypes_Add?.length ? ev.TicketTypes_Add = ev.TicketTypes_Add?.filter(item => item.No !== 0) : ev.TicketTypes_Add 

     ev.TicketTypes_Remove = ev.TicketTypes_Remove?.length ? ev.TicketTypes_Remove = ev.TicketTypes_Remove?.filter(item => item.No !== 0) : ev.TicketTypes_Remove
     
     setWaitingModal(true)

      setTimeout(function () {
          if(flag === false) {      
            setApiLoader(true)           
          } 
         }, 2000)
   
  const res = await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
            method: "POST",    
            headers: {
             'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
             'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(ev)}`
            
            })
  
    if(res.status === 200)  { 
      flag= true
    }  
   
     else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
    const json = await res.json()
   
    if(json) {
        setWaitingModal(false)
        setApiLoader(false)
        if(json.Result === 1) { 
         
            setEventSaveObj(json)  
         }
          else if(json.Result === -1) {
           
            eventPushCheck()
          }
         else if (json.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
         else  {
          setShowErrorModal(true)
          setErrorNo(json.Result)
          setErrorText(json.ErrorDescription)
        }
       }
     
    }
    
 
  function handleShowFilm () {
        setShowFilm( (current) => !current)
        setQ('')
        setFilmSearch([])
  }

    
  // ---- creating programmed films object ---
let moviesOnDate = Object.assign([],  allMovies)
let moviesPerDay = moviesOnDate.length > allMovies.length ? moviesOnDate : allMovies
if( newDraggedFilm) moviesPerDay.push(newDraggedFilm)

function findLocationId (i) {
    let id 
    allMovies.map((m) => {
      numberOfSal.map((s) => {

        if(s.No === i.locationId && m.No === i.movieId) {
        
           id = s.No
        }
       })
    })
    return id
}

  function findLocations (i) {
    
    let sal
         moviesPerDay.map((m) => {
          numberOfSal.map((s) => {

            if(s.No === i.locationId && m.No === i.movieId) {
            
               sal = s.name
            }
           })
        })
        return sal
  }
  

 

  function findMovieName (i) {
    let name 
    moviesPerDay.map((movie) => {
          
            if(i.movieId === movie.No) {
              name= movie.name
            }         
     })
     return name
  }
  
  function hasMovieLength (i) {
   
    let hasLength = false
    moviesPerDay.map((movie) => {
        if (movie.No === i.movieId) {
         
          movie.length > 0 ? hasLength = true: hasLength = false
        }
      })
      return hasLength
  }

  function findFDuration (i) {
      let length 
      allMovies.map((movie) => {
        if (movie.No === i.movieId) {
          length = movie.length
        }
      })
      return length > 0 ? length : 120   // if film does not have any length then it should be by default 120 (in minutes) 2 hours by default
  }



// ------------FILTERING EVENTS PER DATE --------------
 
  let same = eventSaveObj && eventsEdit.find(ev => 
       { return  ev?.No === eventSaveObj?.No && ev.RefNo === eventSaveObj.RefNo
       
       })

// if refno from eventSaveObj is not same as an event refno in eventsedit only then add it to 
   eventSaveObj &&  !same && eventsEdit.push(eventSaveObj)

    // updating eventsEdit with new man event save object
   useEffect(() => {
    
     if(eventSaveObj) {
      
    const modifiedEv = eventsEdit.map(item => (eventSaveObj.RefNo > 0 ?   item.RefNo === eventSaveObj.RefNo : item.No === eventSaveObj.No) ? eventSaveObj : item)

            setEventsEdit(modifiedEv)
          }
     }, [eventSaveObj]);

  
   // copied_events is used for creating a copy of object and for changing the variables in it to be given to event_save later in the code
   let copied_events = JSON.parse(JSON.stringify(allEvents))
  
 

   let updatedEvents =  copied_events.map(ev => 
     eventsEdit.find(e => e?.No === ev.No) ? eventsEdit.find(e => e?.No === ev.No) :   ev
) 

  //  // updated events are the events which already existed before later changed or not changed
 
   let newlyCreatedEvs = eventsEdit &&  eventsEdit.filter(e => e?.No === 0)          // newly created events which has  event no 0


   let mergedEvents = newlyCreatedEvs && [...updatedEvents,  ...newlyCreatedEvs]



   let all_days_events = []

 

   number_of_days_array.forEach(async (element) =>  {
  
   let eventsalldays =  mergedEvents.filter(e => moment(e.start).format('DD-MM-YYYY') == moment(element).format('DD-MM-YYYY')) 
     all_days_events.push(...eventsalldays)
   
}) 

 

    function calculateY (e) {
      let salIndex
     
      for(let x=0;x<numberOfSal.length;x++)
      {
       
         if (numberOfSal[x].No === e.locationId)
         {
           salIndex=x
           break;
         }
      } 
     
      let rowheight = (document.getElementById('t_body')?.clientHeight/numberOfSal.length)
      let y =  52 + (salIndex * rowheight)
    
   return Math.round(y+3)
   
    }
 
function findLocIndex (i) {
  let salIndex
  for(let x=0;x<numberOfSal.length;x++)
  {
     if (numberOfSal[x].No === i.locationId)
     {
       salIndex=x
       break;
     }
  }
    return salIndex
}

function findTickettypesName (e) {

  let name 
  allTicketTypes.map((type) => {
    if(e.ArrTypeNo === type.No) {
      name = type.Name
    }
  })
  return name

}

  let ProgrammedEvents = []
  let times = []
  let dateTimesArr = []
  let showEndTime = []
  
  const [dragProgrammed,   setDragProgrammed] = useState(false)
  const [theDraggedElm,    setTheDraggedElm]  = useState([])



  for(let i = 0; i < all_days_events.length; i++) {
    if(all_days_events[i].movieId > 0) {
      ProgrammedEvents.push({
      eventObject:all_days_events[i],
      movieSelected:moviesSelected,
      eventEdit: eventsChanged,
      isOpen:showDropdown,
      index : findLocIndex(all_days_events[i]),
      event_No :all_days_events[i].No,
      name:   findMovieName(all_days_events[i]),
      movieLength:hasMovieLength(all_days_events[i]),
      length: findFDuration(all_days_events[i]),
      y_axis: calculateY(all_days_events[i]),
      x_axis: 0,
      ref_No : all_days_events[i].RefNo,
      locationId: findLocationId(all_days_events[i]),
      start: moment(all_days_events[i].start).format('HH:mm'),     
      end: moment(moment(all_days_events[i].start).add(findFDuration(all_days_events[i]), 'm').toDate()).format('HH:mm'),
      sal: findLocations(all_days_events[i]),
      ArrTypeName: all_days_events[i].ArrTypeName,
      webReserveInfo: all_days_events[i].WebreserveInfo?.enabled,
      webbuyInfo: all_days_events[i].WebbuyInfo?.enabled,
      webshowInfo: all_days_events[i].WebshowInfo?.enabled,
      buyEnabled: all_days_events[i].BuyEnabled,
      reserveEnabled: all_days_events[i].ReserveEnabled,
      numberedSeats:all_days_events[i].hasNumberedSeats,
      priceGroups:all_days_events[i].PriceGroups,
      tickettypes: findTickettypesName(all_days_events[i]),
      ArrTypeNo:all_days_events[i].ArrTypeNo,
      UsePriceGroupTemplate:all_days_events[i].UsePriceGroupTemplate,
      UseTicketTypeTemplate:all_days_events[i].UseTicketTypeTemplate
    })

    times.push(moment(all_days_events[i].start).format('HH:mm'))
    dateTimesArr.push(moment(all_days_events[i].start).format('YYYY-MM-DD HH:mm'))
    showEndTime.push(moment(moment(all_days_events[i].start).add(findFDuration(all_days_events[i]), 'm').toDate()).format('YYYY-MM-DD HH:mm'))
   
  }
  }

     dateTimesArr = dateTimesArr.sort()
     showEndTime  =  showEndTime.sort()

useEffect(() => {
   selectAllFilmAtOnce === true ? setMoviesSelected(true) : setMoviesSelected(false)
},[selectAllFilmAtOnce,setMoviesSelected])


// retriving the first start time of movies among all when multiple days are chosen 
  let start_times = []
  let end_times = []
  ProgrammedEvents.forEach((ev) => {
    start_times.push(ev.start)
    end_times.push(ev.end.split(":")[0] == '00' ?  '24' : ev.end.split(":")[0] == '01' ?  '25' : ev.end.split(":")[0] == '02' ?  '26' :ev.end.split(":")[0] == '03' ?  '27' :  ev.end)
  })
  
  let last_end_time = end_times.slice().sort().pop()
  let first_start_time = start_times.slice().sort()[0]


   const [comitCount, setComitCount] = useState();
   const [callPush, setCallPush] = useState(false);
   const [changesMax, setChangesMax] = useState(0);
   const [commitOk, setCommitOk] = useState(false);

   const [commitSuccess, setcommitSuccess] = useState(false);

   function handleCommitOk () {
    let docs = document.getElementById('tes')
    let g = document.getElementsByClassName('overlap-modal')[0]
    docs.removeChild(g)
     setCommitOk(true)
   }

 function handleAllCancelOk () {
   let docs = document.getElementById('tes')
    let g = document.getElementsByClassName('overlap-modal')[0]
    docs.removeChild(g)
    window.location.reload()
 }

  // GEM KUN VALGTE I BILLETSYSTEM
 async function saveChosenInSystem () {
   let count = 0
let docs = document.getElementById('tes')
let modalBack = document.createElement('div')
modalBack.className='overlap-modal '
 modalBack.style.left=Math.round(leftMargin)+'px'
 modalBack.style.height= Math.round(clientHeight)+'px'
let modalContent = document.createElement('div')
modalContent.className='overlap-content'
modalContent.style.width='853px'
modalContent.style.top = '2%'
let overlapContainer = document.createElement('div')
overlapContainer.id='overlap'
let titleDiv = document.createElement('div')
titleDiv.className='title-div'
let text = document.createElement('p')
text.innerHTML='Commit er i gang'
text.className='bemark'
let okBtn = document.createElement('button')
okBtn.innerHTML='OK'
okBtn.className='ok-btn'
okBtn.addEventListener('click', handleCommitOk)
modalContent.appendChild(titleDiv)
titleDiv.appendChild(text)
modalBack.appendChild(modalContent)
modalContent.appendChild(overlapContainer)

 let counterdiv = document.createElement("div")
       modalContent.appendChild(counterdiv)
       counterdiv.className='api-counter'

 let h4 =   document.createElement('p')
 h4.className='overlap-title'
  h4.innerHTML = 'List herunder viser hvordan commit er gået for en enkelte forestilling.'
  h4.style.width='100%'
  overlapContainer.appendChild(h4)

let count_max = document.createElement('p')

    let counter = document.createElement('p')
    counterdiv.appendChild(counter)
    counterdiv.appendChild(count_max)
  let status = document.createElement('p')


      for (let index = 0; index < chosenMovies.length; index++) {
     
        let ev = chosenMovies[index]    
        let theEv = Object.assign({},ev.eventObject)
        
        let film_name = ev.name 
        let date_time = theEv.start      
        let div =  document.createElement("div");
        div.className ='overlap_list'
        div.style.gridTemplateColumns = '0.8fr 0.2fr 0.01fr 0.5fr 0.01fr'
        let name = document.createElement('p')
        let check_icon = document.createElement('img')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
       
        name.innerHTML = film_name +' '+ moment(date_time).format('DD-MM-YYYY') + ' kl.' + date_time.split('T')[1].slice(0, 5)
        div.appendChild(name)
        div.appendChild(check_icon)
        div.appendChild(date)
        div.appendChild(timestart)
       
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
        overlapContainer.appendChild(div)

        
      let flag = false 
      async function eventCommit () {       
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)      
          } 
         }, 2000)

     const res =  await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_commit` ,{
             method: "POST",    
             headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                 'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
            
            })
 if(res.status === 200)  { 
      flag= true
    }  
    else {    
       
           setShowErrorModal(true)
           setErrorStatus(res.status)
           setErrorType(res.type)       
        }
    const json = await res.json()
 if(json) {
       if (json.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }

       else if(json.Result === 1){ 
          check_icon.src = greenCheck
          timestart.innerHTML = 'commit gennemført'       
          setApiLoader(false)
          setcommitSuccess(true)
        }
        else {
          setPushModal(false)
          setCommitOk(false)
          check_icon.src =  redCheck 
          check_icon.style.height='20px'
          timestart.innerHTML ='fejlet med kode '+ json.Result + json.ErrorDescription
        }
          }
        }
        
        await eventCommit()
          count = count + 1
       

        setComitCount(count)
     
 
  }  // loop ends here
    text.innerHTML='Commit er slut'
    modalContent.appendChild(okBtn)
  
}

const [event_push_error, setEvent_push_error] = useState(false);

let interval

useEffect(() => {
  // calling man event push check every 2 seconds untill changesLeft is 0
  if(changesLeft > 0 && changesLeft !== 0 && event_push_error === false) {
   interval =  setInterval(eventPushCheck, 2000)
  }
  return () => clearInterval(interval)
}, [changes, changesLeft]);



useEffect(() => {  
   if(commitOk === true && commitSuccess === true) {
    setPushModal(true)
    setCallPush(true)  // call man event push when ok btn in commit modal is clicked

   }
}, [commitOk, commitSuccess]);



useEffect(() => {
 
  // if callpush is true call man event push
  if(callPush === true ) {
    // document.getElementsByClassName('overlap-modal')[0].style.display='none'
   
     eventPush()

  }

}, [callPush]);



// ----------DELETE EVERYTHING FROM GHOST (EVENTS EDIT) with man_event_cancel call
 async function deleteAllInSystem () {
  let count = 0
  let docs = document.getElementById('tes')
  let modalBack = document.createElement('div')
  modalBack.className='overlap-modal '
  modalBack.style.left=Math.round(leftMargin)+'px'
  modalBack.style.height= Math.round(clientHeight)+'px'
  let modalContent = document.createElement('div')
  modalContent.className='overlap-content'
  modalContent.style.width='853px'
   modalContent.style.top = '2%'
  let overlapContainer = document.createElement('div')
  overlapContainer.id='overlap'
  let titleDiv = document.createElement('div')
  titleDiv.className='title-div'
  let text = document.createElement('p')
  text.innerHTML='Annullering er i gang'
  text.className='bemark'

  modalContent.appendChild(titleDiv)
  titleDiv.appendChild(text)
  modalBack.appendChild(modalContent)
  modalContent.appendChild(overlapContainer)
  let counterdiv = document.createElement("div")
  modalContent.appendChild(counterdiv)
  counterdiv.className='api-counter'
  let h4 =   document.createElement('p')
  h4.className='overlap-title'
  h4.innerHTML = 'List herunder viser hvordan annullering er gået for en enkelte forestilling.'
  h4.style.width='100%'
  overlapContainer.appendChild(h4)
  let count_max = document.createElement('p')
  let counter = document.createElement('p')
  counterdiv.appendChild(counter)
  counterdiv.appendChild(count_max)
  let status = document.createElement('p')

   for (let index = 0; index < eventsEdit.length; index++) {
        const ev = eventsEdit[index];
        let theEv = Object.assign({},ev)
       
        let film_name = allMovies.find((movie => { return theEv.movieId === movie.No})).name 
       
        let date_time = theEv.start
        
        let div =  document.createElement("div");
        div.className ='overlap_list'
        div.style.gridTemplateColumns = '0.8fr 0.2fr 0.01fr 0.4fr 0.01fr'
        let name = document.createElement('p')
        let sal = document.createElement('p')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
        let check_icon = document.createElement('img')
        name.innerHTML = film_name +' '+ moment(date_time).format('DD-MM-YYYY') + ' kl.' + date_time.split('T')[1].slice(0, 5)
         div.appendChild(name)
        div.appendChild(sal)
        div.appendChild(date)
        div.appendChild(timestart)
        div.appendChild(check_icon)
       
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
       overlapContainer.appendChild(div)
 
       let flag = false 
        ev.AllowOverlap = 1 

        async function eventCancel () {   
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)        
          } 
         }, 2000)

     const res =  await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_cancel` ,{
             method: "POST",    
             headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                 'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
            
            })
         if(res.status === 200)  { 
             flag= true
            }  
          else {              
              setShowErrorModal(true)
              setErrorStatus(res.status)
              setErrorType(res.type)       
           }
       const json = await res.json()
        if(json) {
          if (json.Result === 0) {
            // log out
            logOut()
            navigate('/') 
          } 
           else if(json.Result === 1){ 
             check_icon.src = greenCheck
             timestart.innerHTML = 'annullering gennemført'
           
             setApiLoader(false)
             setcommitSuccess(true)
        }
            else  {
              setPushModal(false)
              setCommitOk(false)
              check_icon.src =  redCheck 
              check_icon.style.height='20px'
              timestart.innerHTML ='fejlet med kode '+ json.Result + json.ErrorDescription
          }
                             
          }
        }
    
         await eventCancel()
      //   count= count + 1
        
        // setComitCount(count)
  
 
 }  // loop ends here
     text.innerHTML='Annullering er slut'
      let okBtn = document.createElement('button')
      okBtn.innerHTML='OK'
      okBtn.className='ok-btn'
      modalContent.appendChild(okBtn)
      okBtn.addEventListener('click', handleAllCancelOk)
      modalContent.appendChild(okBtn)

 }

// ------------GEM  ALLE DAGES RETTELSER I BILLETSYSTEM-------------everything from event save/ghost
 async function saveAllInSystem () {
  
  let count = 0
  let docs = document.getElementById('tes')
  let modalBack = document.createElement('div')
  modalBack.className='overlap-modal '
  modalBack.style.left=Math.round(leftMargin)+'px'
  modalBack.style.height= Math.round(clientHeight)+'px'
  let modalContent = document.createElement('div')
  modalContent.className='overlap-content'
  modalContent.style.width='853px'
  modalContent.style.top = '2%'
  let overlapContainer = document.createElement('div')
  overlapContainer.id='overlap'
  let titleDiv = document.createElement('div')
  titleDiv.className='title-div'
  let text = document.createElement('p')
  text.innerHTML='Commit er i gang'
  text.className='bemark'

  modalContent.appendChild(titleDiv)
  titleDiv.appendChild(text)
  modalBack.appendChild(modalContent)
  modalContent.appendChild(overlapContainer)
  let counterdiv = document.createElement("div")
  modalContent.appendChild(counterdiv)
  counterdiv.className='api-counter'
  let h4 =   document.createElement('p')
  h4.className='overlap-title'
  h4.innerHTML = 'List herunder viser hvordan commit er gået for en enkelte forestilling.'
  h4.style.width='100%'
  overlapContainer.appendChild(h4)
  let count_max = document.createElement('p')
  let counter = document.createElement('p')
  counterdiv.appendChild(counter)
  counterdiv.appendChild(count_max)
  let status = document.createElement('p')
  //  let chosenMovies =  updateProgram.filter(pro => { return pro.movieSelected === true })

  for (let index = 0; index < eventsEdit.length; index++) {
    const ev = eventsEdit[index];
    
  
        let theEv = Object.assign({},ev)
       
        let film_name = allMovies.find((movie => { return theEv.movieId === movie.No})).name 
       
        let date_time = theEv.start
        
        let div =  document.createElement("div");
        div.className ='overlap_list'
        div.style.gridTemplateColumns = '0.8fr 0.2fr 0.01fr 0.4fr 0.01fr'
        let name = document.createElement('p')
        let sal = document.createElement('p')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
        let check_icon = document.createElement('img')
        
        name.innerHTML = film_name +' '+ moment(date_time).format('DD-MM-YYYY') + ' kl.' + date_time.split('T')[1].slice(0, 5)

       
         div.appendChild(name)
        div.appendChild(sal)
        div.appendChild(date)
        div.appendChild(timestart)
        div.appendChild(check_icon)
       
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
       overlapContainer.appendChild(div)
 
       let flag = false 
        ev.AllowOverlap = 1 

        async function eventCommit () {   
         setTimeout(function () {
           if(flag === false) {         
               setApiLoader(true)        
          } 
         }, 2000)

     const res =  await  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_commit` ,{
             method: "POST",    
             headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                 'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
            
            })
         if(res.status === 200)  { 
             flag= true
            }  
          else {    
           
              setShowErrorModal(true)
              setErrorStatus(res.status)
              setErrorType(res.type)       
           }
       const json = await res.json()
        if(json) {
          if (json.Result === 0) {
            // log out
            logOut()
            navigate('/') 
          } 
           else if(json.Result === 1){ 
             check_icon.src = greenCheck
             timestart.innerHTML = 'commit gennemført'
           
             setApiLoader(false)
             setcommitSuccess(true)
        }
            else  {
              setPushModal(false)
              setCommitOk(false)
              check_icon.src =  redCheck 
              check_icon.style.height='20px'
              timestart.innerHTML ='fejlet med kode '+ json.Result + json.ErrorDescription
          }
                             
          }
        }
    
         await eventCommit()
         count= count + 1     
         setComitCount(count)
  
 
 }  // loop ends here
     text.innerHTML='Commit er slut'
      let okBtn = document.createElement('button')
      okBtn.innerHTML='OK'
      okBtn.className='ok-btn'
      modalContent.appendChild(okBtn)
      okBtn.addEventListener('click', handleCommitOk)
      modalContent.appendChild(okBtn)
}


//--------- 4 button click functions -----------
function handleSelectAll () {

  setSelectAllFilmAtOnce((current) => !current)
  setchosenMovies(updateProgram)
  // setchosenMovies(prev => prev.length === 0 ? updateProgram : [])
}

useEffect(() => {
  selectAllFilmAtOnce === true ? setchosenMovies(updateProgram) : setchosenMovies([])
}, [selectAllFilmAtOnce]);

function handleCopy () {
  (selectAllFilmAtOnce || anyMovieSelected) &&
  setCopyChosen(true)
}


function cancelCopy () {
setDeletebtnclk(true)

setCopyChosen(false)
setSelectAllFilmAtOnce(false)
setAnyMovieSelected(false)
 setchosenMovies([])

}


//-----function below is used to calculate days between startdate and enddate chosen for copying
function enumerateDaysBetweenDates (date1, date2){
  let date = []
  while(moment(date1) <= moment(date2)){
    date.push(date1);
    date1 = moment(date1).add(1, 'days').format("YYYY-MM-DD");
  }
  return date;
}

const [ overlapDiv, setOverlapDiv] = useState(false)



function handlecopyclosebtn () {
  setOverlapDiv(false)
 
  let docs = document.getElementById('tes')

  let g = document.getElementsByClassName('overlap-modal')[0]

  docs.removeChild(g)

 setSelectAllFilmAtOnce(false)
 setCopied(true)  // makes getprogram run again
 window.location.reload()
}

const [copyObject, setCopyObject] = useState([]);

const clientHeight =allMovies.length && document.getElementById('tes').clientHeight


  let theChosedDays = enumerateDaysBetweenDates(moment(startDate).format('YYYY-MM-DD'),moment(endDate).format('YYYY-MM-DD'))

  const [dateError, setDateError] = useState(false);

  useEffect(() => {
    if(moment(endDate).isBefore(startDate) || !endDate) setDateError(true)
      else setDateError(false)
  }, [endDate, startDate]);


async function saveCopy () {
  setCopied(false)
  if(!dateError) { 
       setShowCopyModal(true)

let docs = document.getElementById('tes')
let modalBack = document.createElement('div')
modalBack.className='overlap-modal '

 modalBack.style.left=Math.round(leftMargin)+'px'
 modalBack.style.height= Math.round(clientHeight)+'px'

let modalContent = document.createElement('div')
modalContent.className='overlap-content'

modalContent.style.width='853px'


let overlapContainer = document.createElement('div')
overlapContainer.id='overlap'
let titleDiv = document.createElement('div')
titleDiv.className='title-div'
let text = document.createElement('p')
text.innerHTML='Kopiering er i gang'
text.className='bemark'
let close_btn = document.createElement('button')
close_btn.innerHTML='X'
close_btn.className='close-btn'
close_btn.addEventListener('click', handlecopyclosebtn)
let okBtn = document.createElement('button')
okBtn.innerHTML='OK'
okBtn.className='ok-btn'

okBtn.addEventListener('click', handlecopyclosebtn)
modalContent.appendChild(titleDiv)
titleDiv.appendChild(close_btn)
titleDiv.appendChild(text)
modalBack.appendChild(modalContent)
modalContent.appendChild(overlapContainer)

 let counterdiv = document.createElement("div")
       modalContent.appendChild(counterdiv)
       counterdiv.className='api-counter'

    let h4 =   document.createElement('p')
    h4.className='overlap-title'
    h4.innerHTML = 'List herunder viser de fejl der er opstået ved kopiering'
    overlapContainer.appendChild(h4)
    setCopyObject(chosenMovies)
    let count = 0
    let count_max = document.createElement('p')
    count_max.innerHTML = chosenMovies.length *  theChosedDays.length
    count_max.className='count_max'
    let counter = document.createElement('p')
    counterdiv.appendChild(counter)
    counterdiv.appendChild(count_max)


 for (let i = 0; i <  theChosedDays.length; i++) {

        for (let index = 0; index < chosenMovies.length; index++) {
        let theEvent = chosenMovies[index]
     
        let save = true
          
        let ev =  Object.assign({}, theEvent.eventObject)
        let the_ev =  Object.assign({}, theEvent)
        ev.No = 0 // ev with event no 0
        ev.RefNo = 0  // ev with RefNo 0
        ev.AllowOverlap = 1
        ev.start = theChosedDays[i]+'T'+moment(ev.start).format('HH:mm:ss')  // ev with new date
         ev.AdvertisementTrailer  = localStorage.getItem('adTrailerTime')  // setting advertisementTrailer when creating new show
              
        let m_ev =   allMovies.filter(movie => { return movie.No === ev.movieId})     
        let new_event_start = ev.start          
        const minutes = m_ev[0].length+Number(ev.AdvertisementTrailer)
  
        let new_event_end = addMinutes(new Date(ev.start),minutes)
       
           
        let overlap = false
        let flag = false
        
     // Kig alle events igennem for at finde dem der rammer dato og sal
        mergedEvents.map( (event) => {

          if (moment(event.start).format('YYYY-MM-DD') === theChosedDays[i] && event.locationId === ev.locationId) {
         
           let m =     allMovies.filter(movie => { return movie.No === event.movieId})
          
            let original_event_start = event.start
         
            let original_event_end = moment(moment(event.start).add(m[0].length+event.AdvertisementTrailer, 'm')).format('YYYY-MM-DD HH:mm')
        
               setOverlapModal(true)
                            console.log(moment(new_event_start).format('HHmm'))
                            console.log(moment(original_event_end).format('HHmm'))
                            console.log( moment(new_event_end).format('HHmm'))
                            console.log(moment(original_event_start).format('HHmm'))
                if(moment(new_event_start).format('HHmm') < moment(original_event_end).format('HHmm') && moment(new_event_end).format('HHmm') > moment(original_event_start).format('HHmm'))
                 {
                 
                    overlap = true               
                    save= false
               
                  }
   
           }
          
      })
       let status = document.createElement('p')

        let div =  document.createElement("div");
        div.className ='overlap_list'
        let name = document.createElement('p')
        let sal = document.createElement('p')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
        // let timeend = document.createElement('p')
        name.innerHTML = the_ev.name
        sal.innerHTML = the_ev.sal
        date.innerHTML = moment(ev.start).format('DD-MM-YYYY')
        timestart.innerHTML = moment(ev.start).format('HH:mm')
       
        div.appendChild(name)
        div.appendChild(sal)
        div.appendChild(date)
        div.appendChild(timestart)
        // div.appendChild(timeend)
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
 
      if(overlap) {
        overlapContainer.appendChild(div)      
        status.innerHTML = 'forestilling overlap'     
       }
       else  { 
     
      async function eventSaveCopy () {
         ev.AllowOverlap = 1 
    ev.TicketTypes_Add = ev.TicketTypes_Add?.length ? ev.TicketTypes_Add = ev.TicketTypes_Add?.filter(item => item.No !== 0) : ev.TicketTypes_Add // if tickettype_add has No 0 then removing it

     ev.TicketTypes_Remove = ev.TicketTypes_Remove?.length ? ev.TicketTypes_Remove = ev.TicketTypes_Remove?.filter(item => item.No !== 0) : ev.TicketTypes_Remove // if tickettype_remove had No 0 then removing it
        setWaitingModal(true)
        
       setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
          
            
          } 
         }, 2000)
      
      
     const res =  await   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
             method: "POST",    
            headers: {
             'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
             'Content-Type':  'application/x-www-form-urlencoded',            
            },        
            body:`Key=${key}&eventdata=${JSON.stringify(ev)}`
            
            })
           
 
     if(res.status === 200)  { 
         flag =  true
     }  
    else {    
           setShowErrorModal(true)
           setErrorStatus(res.status)
           setErrorType(res.type)       
        }
    const json = await res.json()
    flag =  true
      
  
    if(json) {
        setWaitingModal(false)
        setApiLoader(false)
        
        if(json.Result === 1) { 
            setEventSaveObj(json)  
            status.innerHTML = 'oprettet'
          }
            else if (json.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(json.Result === -1) {
          
            eventPushCheck()
          }
          else {
             let status = document.createElement('p')

        let div =  document.createElement("div");
        div.className ='overlap_list'
        let name = document.createElement('p')
        let sal = document.createElement('p')
        let date = document.createElement('p')
        let timestart = document.createElement('p')
        // let timeend = document.createElement('p')
        name.innerHTML = the_ev.name
        sal.innerHTML = the_ev.sal
        date.innerHTML = moment(ev.start).format('DD-MM-YYYY')
        timestart.innerHTML = moment(ev.start).format('HH:mm')
       
        div.appendChild(name)
        div.appendChild(sal)
        div.appendChild(date)
        div.appendChild(timestart)
        // div.appendChild(timeend)
        div.appendChild(status)
      
        docs.appendChild(modalBack) 
 
       overlapContainer.appendChild(div)
        status.innerHTML =`Error ${json.Result} : ${json.ErrorDescription},` 

          }
 }
        }
       
        await   eventSaveCopy()   
      
      }
         
          count = count + 1
          counter.innerHTML = count
      }     
   

   }  // for loop ends here
 text.innerHTML='Kopiering er slut'
modalContent.appendChild(okBtn)
 setOverlapDiv(true)
 setCopyChosen(false)
 setSelectAllFilmAtOnce(false)


  }
  
}
  

// man_event_push call
function eventPush () {  
    setWaitingModal(true)

   fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_push` ,{
        method: "POST",     
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',     
       },
       body:`Key=${key}&orgNo=${default_filmID ? default_filmID : orgSelect}`
   })
    .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => {
       setWaitingModal(false)
       setApiLoader(false)
      //  if(result.Result === 1) {
      setChangesMax(result.ChangesLeft)
       setChangesLeft(result.ChangesLeft)
        if(result.Result === 0 ) {
         // log out
           logOut()
           navigate('/') 
        }
        else { 
              if(result.Result > 1) {
                 setEvent_push_error(true)
                 setShowErrorModal(true)
                 setErrorNo(result.Result)
                 setErrorText(result.ErrorDescription)
              }
              if(result.ChangesLeft === 0) {
               // setPushModal(false)
                //  window.location.reload()
              }
            }
      })
      setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
        
            
          } 
         }, 2000)
     
}


function handleEdit () {

  (selectAllFilmAtOnce || anyMovieSelected) && setEditChosen((current => !current))
    //  let chosenMovies =  updateProgram.filter(pro => { return pro.movieSelected === true })
   
    setGrpEditArr(chosenMovies)

}
console.log(chosenMovies)

function deleteEvent () {
 
   chosenMovies.map((ev) => {
    let theEv = ev.eventObject
    if(theEv.No > 0) {  // if existing forestilling
        theEv.DeleteEvent = 1
        console.log(theEv)
          eventSave(theEv)
          window.location.reload()

    } 
   
     else {
      eventCancel(theEv)  
      window.location.reload()

     }
    })

  }

 function deleteGhostEvent() {
    setEventDelete(true)

    chosenMovies.map((ev) => {
     let theEv = Object.assign({}, ev.eventObject)
 
     eventCancel (theEv)
   })    // event chosen map ending

   setalertEvents('')
   setAnyMovieSelected(false)
   setSelectAllFilmAtOnce(false)

  window.location.reload()

}

 function eventCancel (theEv) {
  setWaitingModal(true)

  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_cancel` ,{
      method: "POST",  
      headers: {
       'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
       'Content-Type':  'application/x-www-form-urlencoded',    
     },
   
     body:`Key=${key}&eventdata=${JSON.stringify(theEv)}`
     
})
     .then(res =>  { 
           flag =  true
    
        if(res.status === 200) {
          return   res.json() 
        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 
          if(result.Result === 0) {
         // log out
           logOut()
           navigate('/') 
          }
          else  {
           setApiLoader(false)
           setWaitingModal(false)
          }
       
     
        })
        setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
         
            
          } 
         }, 2000)
}



function saveTheEdit () {
  if(allStaffTextInput) {
      grpEditArr.map((event) => {
      event.eventObject.StaffInfo = allStaffTextInput
      eventSave(event.eventObject)
      setGroupStaffInfoShown(false)     
   })
  }
  if(allWebTextInput) {
     grpEditArr.map((event) => {
      event.eventObject.StaffInfo = allWebTextInput
      eventSave(event.eventObject)
     })
  }
 
  if(numberedClicked === true ) {
     if(numberedSeat === false) {
           grpEditArr.map((ev) => { 
              ev.eventObject.hasNumberedSeats = false
              eventSave(ev.eventObject)

           })
     }
     else {
            grpEditArr.map((ev) => { 
              ev.eventObject.hasNumberedSeats = true
              eventSave(ev.eventObject)

           })
     }
  }
  if(numbered2Clicked === true) {
      if(numberedSeat2 === 0) {
         grpEditArr.map((ev) => { 
              ev.eventObject.hasNumberedSeats = true
              eventSave(ev.eventObject)

           })
      }
      else if(numberedSeat2 === 1) {
           grpEditArr.map((ev) => { 
              ev.eventObject.hasNumberedSeats = false
              eventSave(ev.eventObject)

           })
      }
      else {
          grpEditArr.map((ev) => { 
              ev.eventObject.hasNumberedSeats = ev.numberedSeats
              eventSave(ev.eventObject)

           })
      }
  }

  if(aclicked === true ) {
    if(interOrder === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.WebreserveInfo ? 
        (ev.eventObject.WebreserveInfo.enabled = 0 ) 
        : (ev.eventObject.WebreserveInfo = {enabled: 0 })
      
        eventSave(ev.eventObject)
        
      })
    }
    else { 
      grpEditArr.map((ev) => {
        ev.eventObject.WebreserveInfo ? 
        (ev.eventObject.WebreserveInfo.enabled = 1 ) 
        : (ev.eventObject.WebreserveInfo = {enabled: 1 })
      
        eventSave(ev.eventObject)
  
      })
    }
  }
  if(a2clicked === true) {
    if(interOrder2 === 0 ) {
      grpEditArr.map((ev) => {

       if( ev.eventObject.WebreserveInfo) {
           if(ev.eventObject.WebreserveInfo.enabled === 0 ) {
            ev.eventObject.WebreserveInfo.enabled = 1 
            eventSave(ev.eventObject)
           }
       } 
        
        else { 
          ev.eventObject.WebreserveInfo = {enabled: 1 }
          eventSave(ev.eventObject)

        } 
       

      })
     // }
      // setInterorderChanged(true)
     }
     else if(interOrder2 === 1) {
      grpEditArr.map((ev) => {
        if(ev.eventObject.WebreserveInfo) {
           if(ev.eventObject.WebreserveInfo.enabled === 1) {
            ev.eventObject.WebreserveInfo.enabled = 0
            eventSave(ev.eventObject)

           }
        } 
       
        else {
          ev.eventObject.WebreserveInfo = {enabled: 0 }
          eventSave(ev.eventObject)

        } 
       
      })
      // setInterorderChanged(true)
     }
     else {
     grpEditArr.map((ev) => {
        ev.eventObject.WebreserveInfo ? 
        (ev.eventObject.WebreserveInfo.enabled = ev.webReserveInfo ) 
        : (ev.eventObject.WebreserveInfo = {enabled:  ev.webReserveInfo })
       
       
      })
      // setInterorderChanged(false)
     }
  }

  if(bclicked === true ) {
    if(interSalg === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.WebbuyInfo? 
        (ev.eventObject.WebbuyInfo.enabled = 0 ) 
        : (ev.eventObject.WebbuyInfo = {enabled: 0 })
        eventSave(ev.eventObject)

       
      })
    }
    else {
      grpEditArr.map((ev) => {
        ev.eventObject.WebbuyInfo? 
        (ev.eventObject.WebbuyInfo.enabled = 1 ) 
        : (ev.eventObject.WebbuyInfo = {enabled: 1 })
        eventSave(ev.eventObject)

       
      })
    }
  }

 if(b2clicked === true ) {
  if(interSalg2 === 0) {
    grpEditArr.map((ev) => {
      if(ev.eventObject.WebbuyInfo) {
         if(ev.eventObject.WebbuyInfo.enabled === 0 ) {
            ev.eventObject.WebbuyInfo.enabled = 1
            eventSave(ev.eventObject)
      }
    } 
    
      else { 
        ev.eventObject.WebbuyInfo = {enabled: 1 }
        eventSave(ev.eventObject)

      }
     
    })
    
  }
  else if( interSalg2 === 1) {
    grpEditArr.map((ev) => {
      if(ev.eventObject.WebbuyInfo){
          if(ev.eventObject.WebbuyInfo.enabled === 1) {
            ev.eventObject.WebbuyInfo.enabled = 0
            eventSave(ev.eventObject)

          }
      }
     
      else {
        ev.eventObject.WebbuyInfo = {enabled: 0 }
        eventSave(ev.eventObject)

      } 
      
    })
   
  }
  else {
    grpEditArr.map((ev) => {
      ev.eventObject.WebbuyInfo? 
      (ev.eventObject.WebbuyInfo.enabled = ev.webbuyInfo ) 
      : (ev.eventObject.WebbuyInfo = {enabled: ev.webbuyInfo  })
    })
    
  }
 }

  if(cclicked === true) {
    if(interShow === false) {
        grpEditArr.map((ev) => {
          ev.eventObject.WebshowInfo ? 
          (ev.eventObject.WebshowInfo.enabled = 0 ) 
          : (ev.eventObject.WebshowInfo = {enabled: 0 })
        eventSave(ev.eventObject)

         
        })
      }
      else {
        grpEditArr.map((ev) => {
          ev.eventObject.WebshowInfo ? 
          (ev.eventObject.WebshowInfo.enabled = 1 ) 
          : (ev.eventObject.WebshowInfo = {enabled: 1 })
        eventSave(ev.eventObject)

         
        })
      }
  }
 if(c2clicked === true) {
     if(interShow2 === 0) {
      grpEditArr.map((ev) => {
        if(ev.eventObject.WebshowInfo) {
           if(ev.eventObject.WebshowInfo.enabled === 0 ) {
              ev.eventObject.WebshowInfo.enabled = 1
              eventSave(ev.eventObject)
        }
      } 
      
        else { 
          ev.eventObject.WebshowInfo = {enabled: 1 }
          eventSave(ev.eventObject)
  
        }
       
      })
     }
     else if(interShow2 === 1) {
       grpEditArr.map((ev) => {
        if(ev.eventObject.WebshowInfo){
            if(ev.eventObject.WebshowInfo.enabled === 1) {
              ev.eventObject.WebshowInfo.enabled = 0
              eventSave(ev.eventObject)
  
            }
        }
       
        else {
          ev.eventObject.WebshowInfo = {enabled: 0 }
          eventSave(ev.eventObject)
  
        } 
        
      })
     }
     else {
      grpEditArr.map((ev) => {
        ev.eventObject.WebshowInfo? 
        (ev.eventObject.WebshowInfo.enabled = ev.webshowInfo ) 
        : (ev.eventObject.WebbuyInfo = {enabled: ev.webshowInfo  })
      })
      
    }
 }
  if(dclicked === true) {
    if(buyEnabled === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.BuyEnabled = 0  
        eventSave(ev.eventObject)
       
        
      })
    }
    else {
      grpEditArr.map((ev) => {
        ev.eventObject.BuyEnabled = 1
        eventSave(ev.eventObject)

      })
    }
  }
  if(d2clicked === true) {
   if(buyEnabled2 === 0) {
       grpEditArr.map((ev) => {
        if(ev.eventObject.BuyEnabled === 0) {
          ev.eventObject.BuyEnabled=1
          eventSave(ev.eventObject)
        }
        // else {
        //   ev.eventObject.BuyEnabled = 0
        //   eventSave(ev.eventObject)

        // }
       })
   }
   else if(buyEnabled2 === 1) {
      grpEditArr.map((ev) => {
        if(ev.eventObject.BuyEnabled === 1) {
          ev.eventObject.BuyEnabled = 0
        }
        // else {
        //   ev.eventObject.BuyEnabled
        // }
      })
   }
   else {
    grpEditArr.map((ev) => {
      ev.eventObject.BuyEnabled = ev.buyEnabled
      
    })
   }
}
  if(eclicked === true) {
    if(resEnabled === false) {
      grpEditArr.map((ev) => {
        ev.eventObject.ReserveEnabled = 0
        eventSave(ev.eventObject)

      })
    }
    else {
      grpEditArr.map((ev) => {
        ev.eventObject.ReserveEnabled = 1
        eventSave(ev.eventObject)

      })
    }
  }
  if(e2clicked === true) {
    if(resEnabled2 === 0) {
      grpEditArr.map((ev) => {
       if(ev.eventObject.ReserveEnabled === 0) {
         ev.eventObject.ReserveEnabled=1
         eventSave(ev.eventObject)
       }
       // else {
       //   ev.eventObject.BuyEnabled = 0
       //   eventSave(ev.eventObject)

       // }
      })
  }
  else if(resEnabled2 === 1) {
     grpEditArr.map((ev) => {
       if(ev.eventObject.ReserveEnabled === 1) {
         ev.eventObject.ReserveEnabled = 0
       }
       // else {
       //   ev.eventObject.BuyEnabled
       // }
     })
  }
  else {
   grpEditArr.map((ev) => {
     ev.eventObject.ReserveEnabled = ev.buyEnabled
     
   })
  }
  }

  setchosenMovies([])
  
   setSelectAllFilmAtOnce(false)
   setEditChosen(false) 
  
   setAnyMovieSelected(false)

  //  setSavebtnclk(true)
  
}



function deleteTheEdit () {
  setAnyMovieSelected(false)
  setDeletebtnclk(true)
 
  setEditChosen((current => !current))
  setSaveFilmEdit(false)
  setGroupStaffInfoShown(false)
  setGroupWebInfoShown(false)
 

  setSelectAllFilmAtOnce(false)
   let eventsprog =  updateProgram.filter(pro => {return pro.movieSelected === true})
   eventsprog.map(ev => {
     ev.movieSelected= false
   })
 
   window.location.reload()
}


function handleStartDatoCal () {
  if(endDatoCal   === true) setEndDatoCal(false)
  setStartDatoCal((current => !current))
}
function handleEndDatoCal () {
  if(startDatoCal === true) setStartDatoCal(false)
  setEndDatoCal((current => !current))
}


// transparent image on drag
    const img = new Image()
    img.src = trans

 
 //------------ runs when dragging the film image starts----------   
 function handleOnDrag (e,widgetType,movie ) {

  e.dataTransfer.effectAllowed = "copyMove";
  setNewDraggedFilm(movie)
  setDraggedMovieId(movie.No)

    e.dataTransfer.setDragImage(img, 0,0)
    e.nativeEvent.hidden = true
    e.dataTransfer.setData('widgetType', widgetType)
    setDraggedFilm(movie.name)
    
    setFilmWidth(e.target.attributes.duration.value == 0 ? '90' : e.target.attributes.duration.value) 
   // setShowFilm((current=> !current))
 }
 //----------runs when dragging the film image ends ---------
 function imgDragEnd(e) { 
  e.dataTransfer.dropEffect === 'none' ? setShowG(false) : setShowG()
  setShowTime(false) 
}


  useEffect(() => {
    setDivOverlap(false)
  }, [selectedStartDate]);


useEffect(() => {
  showFilm === true  && setQ('') 
}, [showFilm]);
  



let updateProgram =  ProgrammedEvents.map((pro) => {
      let refNo = pro.ref_No
      let eventNo = pro.event_No
      let draggedNo = dragProgrammed === true && theDraggedElm.event_No
    
  if(eventNo === draggedNo && pro.name === theDraggedElm.name && refNo === theDraggedElm.ref_No ) {
    return {...pro, index: theDraggedElm.index,sal :numberOfSal[theDraggedElm.index].name, start: theDraggedElm.start, end:theDraggedElm.end,  }
  }
  return pro
  
  })

useEffect(() => {
   setCopyChosen(false)
   setEditChosen(false)  
},[selectedStartDate])


useEffect(() => {
  setError(false)
},[orgSelect])



const leftMargin = allMovies.length && document.getElementById('tes').getBoundingClientRect().x

setLeftMargin(Math.round(leftMargin)+'px')


useEffect(() => { 
  if(eventSaveObj) { 
   
     eventSaveObj.PriceGroups.forEach(item => {
         if (item.Price === 0 && localStorage.getItem('zeroPriceAlert') === 'true') {  
           setEventErrorModal(true)

           setZeroPriceError('Vær opmærksom på at forestillingsprisen er 0 kr.')
         }
    });
   
    const ticketTypes = eventSaveObj.TicketTypes_Add?.length  ? [...eventSaveObj.TicketTypes,  ...eventSaveObj.TicketTypes_Add] : [...eventSaveObj.TicketTypes]
    const merged_ticketypes = ticketTypes.filter(
          item => !eventSaveObj.TicketTypes_Remove?.some(obj => obj.No === item.No)
          );
   
    if( merged_ticketypes.length > 0 ) {
      let tickets_with_default = []

           allTicketTypes.map((at) => {
                 merged_ticketypes.map((t) => {
                   if(t.No === at.No && at.Default === 1) {
                  
                     tickets_with_default.push(at)
                   }
                 })
               })
       
              if(tickets_with_default.length === 0 && localStorage.getItem('ticketTypeAlert') === 'true') {
              
                 setEventErrorModal(true)
                 setManEventErrortext('Der er ikke valgt en primær billettype, så denne forestilling kan ikke gemmes i billetsystem, før det er rettet.')
                 }
              else if(tickets_with_default.length > 1 &&  localStorage.getItem('ticketTypeAlert') === 'true') {
               
                setEventErrorModal(true)
                setManEventErrortext('Der er valgt flere primære billettyper, så denne forestilling kan ikke gemmes i billetsystem, før det er rettet.')
                  }
              else {
                
              }
   }

}
}, [eventSaveObj,allTicketTypes]);


const [showInternetOrder, setShowInternetOrder] = useState(localStorage.getItem('show_internet_order') === "true" ? true : false);
const [showInternetSalg, setShowInternetSalg] = useState(localStorage.getItem('show_internet_salg') === "true" ? true : false);
const [showInternetVis, setShowInternetVis] = useState(localStorage.getItem('show_internt_vis') === "true" ? true : false);

const [showPrice, setShowPrice] = useState(localStorage.getItem('show_price') === "true" ? true : false);
const [showForstype, setShowforstype] = useState(localStorage.getItem('show_forstype') === "true" ? true : false);
const [showPrimaryTkt, setShowPrimaryTkt] = useState(localStorage.getItem('show_primary_tkt') === "true" ? true : false);
const [showStartEndtime, setShowStartEndtime] = useState(localStorage.getItem('show_start_end') === "true" ? true : false);

localStorage.setItem('show_start_end',showStartEndtime )
localStorage.setItem('show_price', showPrice)
localStorage.setItem('show_internet_order', showInternetOrder)
localStorage.setItem('show_internet_salg', showInternetSalg)
localStorage.setItem('show_internt_vis', showInternetVis)
localStorage.setItem('show_forstype', showForstype)
localStorage.setItem('show_primary_tkt',showPrimaryTkt)

function handleShowOrder () {
setShowInternetOrder((current) => !current)
}

function handleShowSalg () {
  setShowInternetSalg((current) => !current)
}

function handleShowVis () {
  setShowInternetVis((current) => !current)
}

function handleShowPris () {
   setShowPrice((current) => !current)
}

function handleShowforstype () {
   setShowforstype((current) => !current)
}
function handlePrimaryTkt () {
   setShowPrimaryTkt((current) => !current)
}
function handleShowstartend () {
   setShowStartEndtime((current) => !current)
}



function handleGroupWebInfo (e) {
  setAllWebTextInput(e.target.innerHTML)
}

function groupWebInfoClick() {
 setGroupWebInfoShown((current) => !current)
}

function handleAllStaffInfo (e) {
 
setAllStaffTextInput(e.target.innerHTML)

}

function saveAllStaffInfo () {

 setStaffInfoSaved(true)
   
}

function deleteAllStaffInfo () {
   grpEditArr.map((event) => {
     event.eventObject.StaffInfo = ''
     eventSave(event.eventObject)
     setGroupStaffInfoShown(false)
   })
}

function deleteAllWebInfo () {
 grpEditArr.map((event) => {
     event.eventObject.WebInfo = ''
     eventSave(event.eventObject)
     setGroupWebInfoShown(false)
   })
}

function groupStaffInfoClick () {
   setGroupStaffInfoShown((current) => !current)
}




    // if modal open prevent scorll
    if(modalOpen === true || modalShown === true || editChosen === true) document.body.style.overflow ='hidden'
   
    


  return (
    <main id='main-frame' programactive='active'  style={{
  
       position:'relative',margin:'auto',}}  >
      
      {
        pushModal === true ? 
       <PushEventModal  changesMax={changesMax} count={comitCount} windowHeight={windowHeight} leftMargin={leftMargin} changesLeft={changesLeft}/>
        : null
      }
      <ManEventErrorModal shown={eventErrorModal} errorText={manEventErrortext} zeroPriceError={zeroPriceError}/>
      <NoteModal shown={copyChosen}/>
      <WaitingModal  shown= {waitingModal}/>  
      <Header programActive='active'/>
     
   

          <section id='tes' className={'programContainer'}
           style={{display:'grid', gridTemplateColumns:document.getElementById('main-frame')?.clientWidth > 2000 ? 'auto 338px' :  'auto 62px',height:'auto',
           }}>
            
           <div className='programContainer_main' style={{paddingLeft:document.getElementById('main-frame')?.clientWidth > 2000 ? '50px' : '10px',paddingRight:document.getElementById('main-frame')?.clientWidth > 2000 ? '60px' : '10px'}}>
               <div className='section-header' style={{display:'flex',justifyContent:'space-between',position:'relative' }}>
                <div>
                     <p className='program_title lato-semibold'>Programlægning</p>
                    <OrgSelect  isloading={isloading} setIsLoading={setIsLoading}/>
                </div>

                <div>
                   <div style={{display:'flex',justifyContent:'center',marginBottom:'15px',position:'relative'}}> <DatePickerStart /> <span style={{margin:'0px 16px'}}> – </span><DatePickerEnd /></div>  
               
                <div className='section-mid-header' >
                  <p className='border-text' style={{position:'absolute',top:'-9px',width:'50px'}}>Visning</p>
                  <p className='border-text' style={{position:'absolute',top:'-9px',right:'90px',width:'170px',textAlign:'left',paddingLeft:'2px'}}>Valgt: <span style={{color:'#46484c',fontWeight:400}}>{chosenMovies.length} af {updateProgram.length} forestillinger</span></p> 
          

     <div style={{marginLeft:'10px'}} className='setting_points'>
        <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> 
     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M15.6667 12.0001H14.6667V2.33341C14.6667 1.96522 14.3682 1.66675 14 1.66675H2C1.63181 1.66675 1.33333 1.96522 1.33333 2.33341V12.0001H0.333333C0.149238 12.0001 0 12.1493 0 12.3334V12.6667C0 13.0349 0.298477 13.3334 0.666667 13.3334H15.3333C15.7015 13.3334 16 13.0349 16 12.6667V12.3334C16 12.1493 15.8508 12.0001 15.6667 12.0001ZM2.66667 3.00008H13.3333V11.3334H2.66667V3.00008Z" fill="#46484C"/>
</svg>
      <span className='orders'>Internetbestilling</span>
    <span style={{position:'absolute',top:'-6px',left:'4px'}}><svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
<g clip-path="url(#clip0_3249_27311)">
<path d="M7.00004 3.67859V4.32145C7.00004 4.49897 6.85613 4.64288 6.67861 4.64288H4.64288V6.67861C4.64288 6.85613 4.49897 7.00004 4.32145 7.00004H3.67859C3.50107 7.00004 3.35716 6.85613 3.35716 6.67861V4.64288H1.32143C1.14391 4.64288 1 4.49897 1 4.32145V3.67859C1 3.50107 1.14391 3.35716 1.32143 3.35716H3.35716V1.32143C3.35716 1.14391 3.50107 1 3.67859 1H4.32145C4.49897 1 4.64288 1.14391 4.64288 1.32143V3.35716H6.67861C6.85613 3.35716 7.00004 3.50107 7.00004 3.67859Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27311">
<rect width="8" height="8" fill="white"/>
</clipPath>
</defs>
</svg></span>
    <span onClick={handleShowOrder} style={{position: 'absolute',right: '1px', bottom:'-3px'}}>
  {
    showInternetOrder === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
     </div>
     <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> 
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3249_27318)">
<path d="M15 6.66658H12.3334L8.48669 1.53325C8.39093 1.40896 8.24358 1.33528 8.08669 1.33325H7.91335C7.75646 1.33528 7.60911 1.40896 7.51335 1.53325L3.66669 6.66658H1.00002C0.815925 6.66658 0.666687 6.81582 0.666687 6.99992V7.66658C0.666687 7.85068 0.815925 7.99992 1.00002 7.99992H1.33335L2.47335 13.0999C2.67434 14.0059 3.47211 14.6546 4.40002 14.6666H11.6C12.5354 14.6639 13.344 14.0131 13.5467 13.0999L14.6667 7.99992H14.98C15.1641 7.99992 15.3134 7.85068 15.3134 7.66658V6.99992C15.3137 6.82336 15.1763 6.67718 15 6.66658ZM5.33335 6.66658L8.00002 3.11325L10.6667 6.66658H5.33335Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27318">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
      <span className='orders'>Internetsalg</span> 
       <span onClick={handleShowSalg} style={{position: 'absolute',right:  '1px', bottom:'-3px'}}>
  {
    showInternetSalg === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
      </div> 
     <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> 
     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3249_27325)">
<path d="M14.6585 7.80005C13.5721 5.07769 10.9254 3.30328 7.99593 3.33339C5.08598 3.31655 2.46074 5.07923 1.3733 7.78005C1.34769 7.85061 1.33417 7.92499 1.33332 8.00005C1.33297 8.0709 1.34655 8.14112 1.3733 8.20672C2.45651 10.9128 5.08269 12.6814 7.99593 12.6667C10.9059 12.6835 13.5311 10.9209 14.6186 8.22005C14.6471 8.15031 14.6607 8.07537 14.6585 8.00005C14.6693 7.93382 14.6693 7.86628 14.6585 7.80005ZM7.99593 10.0001C6.89203 10.0001 5.99714 9.10462 5.99714 8.00005C5.99714 6.89548 6.89203 6.00005 7.99593 6.00005C9.09982 6.00005 9.99471 6.89548 9.99471 8.00005C9.99471 8.53049 9.78412 9.03919 9.40928 9.41427C9.03443 9.78934 8.52604 10.0001 7.99593 10.0001Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27325">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
     <span className='orders'>Internetvisning</span> 
     <span onClick={handleShowVis} style={{position: 'absolute',right:  '1px', bottom:'-3px'}}>
  {
    showInternetVis === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
     </div>
    </div>

      <div className='setting_points'>
        <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3249_27333)">
<path d="M14 2.66675H1.99998C1.63179 2.66675 1.33331 2.96522 1.33331 3.33341V12.6667C1.33331 13.0349 1.63179 13.3334 1.99998 13.3334H14C14.3682 13.3334 14.6666 13.0349 14.6666 12.6667V3.33341C14.6666 2.96522 14.3682 2.66675 14 2.66675ZM5.33331 12.0001C5.33331 10.5273 4.13941 9.33342 2.66665 9.33342V6.66675C4.13941 6.66675 5.33331 5.47284 5.33331 4.00008H10.6666C10.6666 5.47284 11.8606 6.66675 13.3333 6.66675V9.33342C11.8606 9.33342 10.6666 10.5273 10.6666 12.0001H5.33331ZM7.99998 6.00008C6.89541 6.00008 5.99998 6.89551 5.99998 8.00008C5.99998 9.10465 6.89541 10.0001 7.99998 10.0001C9.10455 10.0001 9.99998 9.10465 9.99998 8.00008C9.99998 6.89551 9.10455 6.00008 7.99998 6.00008Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27333">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg><span className='orders'>Pris</span> 
<span onClick={handleShowPris} style={{position: 'absolute',right:  '3px', bottom:'-2px'}}>
  {
    showPrice === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
  
    </div>
     <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> 
     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3249_27339)">
<path d="M14.6666 4.00008V5.66675C14.6666 5.85084 14.5174 6.00008 14.3333 6.00008H13.6666C13.4826 6.00008 13.3333 5.85084 13.3333 5.66675V4.00008H11.6666C11.4826 4.00008 11.3333 3.85084 11.3333 3.66675V3.00008C11.3333 2.81599 11.4826 2.66675 11.6666 2.66675H13.3333C14.0697 2.66675 14.6666 3.2637 14.6666 4.00008ZM1.66665 6.00008H2.33331C2.51741 6.00008 2.66665 5.85084 2.66665 5.66675V4.00008H4.33331C4.51741 4.00008 4.66665 3.85084 4.66665 3.66675V3.00008C4.66665 2.81599 4.51741 2.66675 4.33331 2.66675H2.66665C1.93027 2.66675 1.33331 3.2637 1.33331 4.00008V5.66675C1.33331 5.85084 1.48255 6.00008 1.66665 6.00008ZM14.3333 10.0001H13.6666C13.4826 10.0001 13.3333 10.1493 13.3333 10.3334V12.0001H11.6666C11.4826 12.0001 11.3333 12.1493 11.3333 12.3334V13.0001C11.3333 13.1842 11.4826 13.3334 11.6666 13.3334H13.3333C14.0697 13.3334 14.6666 12.7365 14.6666 12.0001V10.3334C14.6666 10.1493 14.5174 10.0001 14.3333 10.0001ZM4.33331 12.0001H2.66665V10.3334C2.66665 10.1493 2.51741 10.0001 2.33331 10.0001H1.66665C1.48255 10.0001 1.33331 10.1493 1.33331 10.3334V12.0001C1.33331 12.7365 1.93027 13.3334 2.66665 13.3334H4.33331C4.51741 13.3334 4.66665 13.1842 4.66665 13.0001V12.3334C4.66665 12.1493 4.51741 12.0001 4.33331 12.0001ZM4.99998 5.33341C4.44769 5.33341 3.99998 5.78113 3.99998 6.33341C3.99998 6.8857 4.44769 7.33342 4.99998 7.33342C5.55226 7.33342 5.99998 6.8857 5.99998 6.33341C5.99998 5.78113 5.55226 5.33341 4.99998 5.33341Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27339">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
     <span className='orders'>Forestillingstype</span> 
   <span onClick={handleShowforstype} style={{position: 'absolute',right:  '3px', bottom:'-3px'}}>
  {
    showForstype === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
     </div> 

     <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> 
     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3249_27347)">
<path d="M14.4733 5.45817L14.0533 5.03903C13.8704 4.8414 13.5863 4.77314 13.3333 4.86605C13.1218 4.95212 12.8951 4.9951 12.6666 4.99246C11.7462 4.99246 11 4.24778 11 3.32918C10.9973 3.10119 11.0404 2.87499 11.1266 2.66386C11.232 2.40385 11.1627 2.1058 10.9533 1.91871L10.5333 1.49957C10.4049 1.38635 10.2378 1.32678 10.0666 1.33324H9.27998C9.10509 1.33397 8.93749 1.40327 8.81331 1.52618L1.52665 8.79804C1.40348 8.92196 1.33405 9.08922 1.33331 9.26376V10.0488C1.33405 10.2234 1.40348 10.3906 1.52665 10.5145L1.94665 10.9337C2.12953 11.1313 2.41367 11.1996 2.66665 11.1067C2.8782 11.0206 3.10487 10.9776 3.33331 10.9803C4.25379 10.9803 4.99998 11.7249 4.99998 12.6435C5.00263 12.8715 4.95956 13.0977 4.87331 13.3089C4.76793 13.5689 4.83726 13.8669 5.04665 14.054L5.46665 14.4732C5.59082 14.5961 5.75842 14.6654 5.93331 14.6661H6.71998C6.89487 14.6654 7.06247 14.5961 7.18665 14.4732L14.4733 7.17468C14.5965 7.05076 14.6659 6.8835 14.6666 6.70896V5.92389C14.6659 5.74936 14.5965 5.5821 14.4733 5.45817ZM7.99998 9.31699C7.2636 9.31699 6.66665 8.72124 6.66665 7.98636C6.66665 7.25148 7.2636 6.65574 7.99998 6.65574C8.73636 6.65574 9.33331 7.25148 9.33331 7.98636C9.33331 8.72124 8.73636 9.31699 7.99998 9.31699Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27347">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
     <span className='orders'>Primær billettype</span>
    <span onClick={handlePrimaryTkt} style={{position: 'absolute',right:  '3px', bottom:'-3px'}}>
  {
    showPrimaryTkt === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'0.1fr 1fr 0.1fr',marginBottom:'5px',position:'relative'}}> 
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g clip-path="url(#clip0_3249_27354)">
<path d="M7.99998 1.33325C4.31808 1.33325 1.33331 4.31802 1.33331 7.99992C1.33331 11.6818 4.31808 14.6666 7.99998 14.6666C11.6819 14.6666 14.6666 11.6818 14.6666 7.99992C14.6666 6.23181 13.9643 4.53612 12.714 3.28587C11.4638 2.03563 9.76809 1.33325 7.99998 1.33325ZM11.0066 10.6666L10.6533 11.0199C10.5214 11.1478 10.3119 11.1478 10.18 11.0199L7.51331 8.35325C7.44821 8.29053 7.412 8.20364 7.41331 8.11325V4.33325C7.41331 4.14916 7.56255 3.99992 7.74665 3.99992H8.25331C8.43741 3.99992 8.58665 4.14916 8.58665 4.33325V7.75992L11.0066 10.1799C11.0722 10.2439 11.1092 10.3316 11.1092 10.4233C11.1092 10.5149 11.0722 10.6026 11.0066 10.6666Z" fill="#46484C"/>
</g>
<defs>
<clipPath id="clip0_3249_27354">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
      <span className='orders' >Starttid og sluttid</span> 
     <span onClick={handleShowstartend} style={{position: 'absolute',right: '3px', bottom:'-3px'}}>
  {
    showStartEndtime === true ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
<path d="M5 7.94495L7.30044 11.1429L11 6" stroke="#46484C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.91667" stroke="#46484C" stroke-width="1.5"/>
</svg>
  }
</span>
      </div>

     </div>
             <span style={{width: '1px',height: '82px',background: '#E3E3E3'}}></span>
             <div>
  <div style={{display:'flex',justifyContent:'space-between',height:'30px'}}>
        {copyChosen && showCopyModal === false ? 
        <> <section style={{zIndex:15,height:'220px',backgroundColor:'white',borderRadius:'8px',width:'210px'}}>
   
      <div >
      <div className='copyDiv' style={{display:'flex',justifyContent:'space-between',height:'44px',}}>
        <p style={{color:'#46484c',fontWeight:'700',marginBottom:'5px',fontSize:'18px',letterSpacing:'0.36px',paddingLeft:'20px',paddingTop:'8px'}}>Kopier valgte</p>
        <button onClick={cancelCopy}><img style={{marginRight:'5x'}} src={close} alt='close-icon'/></button>
</div>
        <div style={{border:  '1px solid #ccced1' ,backgroundColor:'#fff',width:'170px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'2px 5px',margin:'20px'}}>
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#101010', fontWeight:'bold'}}>Startdato:</p> 
               <p style={{fontSize:'16px', color:'#101010',marginTop:'-20px'}}>{start_dato}</p> 
           </div>
           <button style={{marginTop:'-4px'}} onClick={handleStartDatoCal}><img src={calendar} alt="" /></button>        
        </div>
        <div style={{border:'1px solid #ccced1' ,backgroundColor:'#fff',width:'170px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',marginLeft:'20px',marginRight:'20px',marginTop:'-14px'}}>
           <div>
               <p style={{fontSize:'12px', color:'#101010', fontWeight:'bold'}}>Slutdato:</p> 
               <p style={{fontSize:'16px', color:'#101010',marginTop:'-20px'}}> { end_dato  }</p> 
           </div>
           <button style={{marginTop:'-4px'}} onClick={handleEndDatoCal}><img src={calendar} alt="" /></button>        
        </div>
      </div>
         <div className='editBt' style={{display:'flex',marginTop:'12px',justifyContent:'space-between',marginLeft:'20px',marginRight:'18px'}}>
           <button style={{width:'101px',backgroundColor:'#982f2f', fontWeight:'bold',color:'white',height:'40px',borderRadius:'4px'}} onClick={cancelCopy}>ANNULLER</button> 
    
           <button style={{width:'63px',color:'white',fontWeight:'bold',backgroundColor:'#982f2f',height:'40px',borderRadius:'4px'}} onClick={saveCopy}>GEM</button>
      </div>
          </section>
         {startDatoCal ? (
           <div className='startDatoCal'>
             <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',justifyContent:'space-between',margin:'4px',}}>
               <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Startdato</p>
               <button><img src={iconCross} alt="" onClick={handleStartDatoCal}/></button>
             </div>
           <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
        <DayPicker 
         month={month} 
            onMonthChange={setMonth}  locale={da} mode="single" ISOWeek  showOutsideDays  showWeekNumber selected= {startDate}captionLayout="dropdown" fromYear={2022} toYear={2030} onSelect={setStartDate} onDayClick={handleStartDatoCal}  disabled={disabledDays}/>
    </div>
  ) : ''}
  {endDatoCal ? (
    <div className='endDatoCal'>
        <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',   justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Slutdato</p>
           <button onClick={asFirstDate} style={{fontSize:'12px', textDecoration:'underline',color:'grey',}}>Vælg samme som startdato</button>
           <button><img src={iconCross} alt="" onClick={handleEndDatoCal}/></button>
        </div>
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
        </div>
        <DayPicker  month={month} 
            onMonthChange={setMonth}  mode="single" showOutsideDays  showWeekNumber 
            selected= {endDate} captionLayout="dropdown" fromYear={2022} toYear={2030}  ISOWeek
            onDayClick={handleEndDatoCal} onSelect={setEndDate}   
            disabled={disabledDays}/>
    </div>
  ) : ''}


  </> 
    : 
    <button disabled={ !chosenMovies.length  || number_of_days > 1 ? 'disabled'  : '' }
    style={{opacity: !chosenMovies.length  || number_of_days > 1 ? '0.5'  : '',marginLeft:'30px'}} 
     className='copyBtn'  onClick={handleCopy}> KOPIER</button>
    }
    <button style={{opacity: chosenMovies.length > 0 ? '' : '0.5'}} disabled={chosenMovies.length > 0 ? '' : 'disabled'} className='deleteBtn'   onClick={deleteEvent}> SLET</button>

    {editChosen ?
    <section style={{backgroundColor:'white'}}>
    
    <div className='editDiv' style={{zIndex: editChosen === true && modalShown === false  ? 15: 2}}>
       <div>
        <div  style={{display:'flex',justifyContent:'space-between',backgroundColor:'rgba(0,0,0,0.08)'}}>
           <p style={{color:'#46484c',fontWeight:'700',marginBottom:'5px',fontSize:'18px',letterSpacing:'0.36px',paddingLeft:'20px',paddingTop:'10px',height:'44px'}}>Rediger valgte</p>
           <button onClick={deleteTheEdit}><img src={close} alt="close icon" /></button>
        </div>
           <div style={{padding:'20px'}}>
               <div style={{display:'flex',marginTop:'0px',border:'1px  ',height:'14px',marginBottom:'5px',width:'145px',position:'relative'}}>
                {internetorderflag === 2 ? <img onClick={handleInternetOrder2} src= {interOrder2 === 0 ? small_checkmark : interOrder2 === 1 ? small_square : semiCheckbox }  alt=""  /> 
                : 
               <img onClick={handleInternetOrder} src= { interOrder === true ?  small_checkmark:small_square }  alt=""  />
                }
                 <p style={{fontSize:'12px',color:'#46484c',marginTop:'-3px',marginLeft: '6px',textDecoration:'underline'}}>Internetbestilling </p>
                {interorderChanged === true ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px  ',width:'145px',position:'relative'}} >
               {internetsellflag === 2 ?  
               <img onClick={handleInternetSell2} src= {interSalg2 === 0 ? small_checkmark : interSalg2 === 1 ? small_square : semiCheckbox  }  alt=""  />
               : 
               <img onClick={handleInternetSell} src= { interSalg === true ?  small_checkmark : small_square }  alt=""  />}
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'6px',color:'#46484c',textDecoration:'underline'}}>Internet salg</p>
                 {intersalgChanged === true  ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }

               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px ',width:'145px',position:'relative'}} >
               { intershowflag === 2 ?  <img onClick={handleInternetShow2} src= {interShow2 === 0 ? small_checkmark : interShow2 === 1 ? small_square :   semiCheckbox }  alt=""  />  : 
                 <img onClick={handleInternetShow} src= { interShow === true ?  small_checkmark  :small_square }  alt=""  />   
                }        
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'6px',color:'#46484c',textDecoration:'underline'}}>Intervisning</p>
                 {intershowChanged === true   ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px  ',width:'145px',position:'relative'}} >
               {sellticketflag === 2 ?   
                <img onClick={handleTicketSell2} src= {buyEnabled2 === 0 ? small_checkmark : buyEnabled2 === 1 ? small_square : semiCheckbox }  alt=""  /> : 
               <img  onClick={handleTicketSell} src= { buyEnabled === true?  small_checkmark  : small_square }  alt=""  />
              }
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'6px',color:'#46484c',textDecoration:'underline'}}>Salg i billetsalg</p>
                 {buyChanged === true ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

               <div style={{display:'flex',margin:0,padding:0,height:'14px',marginBottom:'5px',border:'1px ',width:'145px',position:'relative'}} >
               {orderticketflag === 2 ?
               <img onClick={handleTicketSellOrder2} src= {resEnabled2 === 0 ? small_checkmark : resEnabled2 === 1 ? small_square :  semiCheckbox }  alt=""  />  : 
               <img onClick={handleTicketSellOrder} src= { resEnabled === true ?  small_checkmark :small_square }  alt=""  />
              }
                 <p style={{fontSize:'12px',padding:'0px',marginTop:'-3px',marginLeft:'6px',color:'#46484c',textDecoration:'underline'}}>Bestilling i billetsalg</p>
                 {resChanged === true ? <img src={ alertIcon} alt='alert-icon' /> : <p style={{color:'transparent'}}>fh</p> }
               </div>

           </div>
          
       </div>
       <div style={{border:'1px ',marginTop:'-15px',marginLeft:'20px',paddingTop:'4px',paddingLeft:'8px', marginRight:'20px',borderRadius:'2px',backgroundColor:'rgba(226, 226, 226, 0.80)',marginBottom:'9px',height:'55px'}}>
         <div style={{display:'flex',justifyContent:'space-between',height:'16px'}}>
           <p style={{margin:0,fontSize:'12px',color:'#46484c',fontWeight:700}}>
            { allPriceGrpsame === true ? 
            chosenMovies[0].priceGroups?.length === 1 ?   chosenMovies[0].priceGroups[0]?.Price :  chosenMovies[0].priceGroups?.length === 2 ?  chosenMovies[0].priceGroups[0].Price +'-'+   chosenMovies[0].priceGroups[1].Price + ' dkk': '' : 'Forskellige pris grupper'}
            </p>
            <button  style={{fontSize:'12px',color:'#46484c',textDecoration:'underline'}} 
            onClick={() => toggleModal(!modalShown)}><img src={edit} alt='edit'/></button>
          </div>
              
               <p style={{margin:0,fontSize:'12px',color:'#46484c',height:'16px'}}> 
                {allForstypeSame === true  && chosenMovies[0].ArrTypeName !== '' ?chosenMovies[0].ArrTypeName : 'Forskellige forestillingstyper' }</p>
               <p style={{margin:0,fontSize:'12px',color:'#46484c',paddingBottom:'3px'}}>
                {allTicketTypeSame === true ?  'Billettype: '+chosenMovies[0].eventObject.TicketTypes.length + ' valgte' : 'Forskellige billettyper'}           
               </p>
           </div>

            <div style={{display:'flex',marginTop:'11px',border:'1px  ',height:'14px',marginBottom:'19px',marginLeft:'20px',position:'relative'}}>
              {numberedSeatflag === 2 ?  
            <img onClick={handleNumeredSeatflag2}  src= {numberedSeat2 === 0 ? small_checkmark : numberedSeat2 === 1 ? small_square : semiCheckbox }  alt="check"  />  
            : <img onClick={handleNumeredSeatflag} src={numberedSeat === true ?  small_square : small_checkmark} alt="check" />   }    
                 <p style={{fontSize:'12px',color:'#46484c',marginTop:'-3px',marginLeft: '6px'}}>Unummererede billetter </p>   
                 {}
            </div>
                <hr style={{margin:'0px'}} />
        <div style={{border:'1px solid  lightgrey',height:groupStaffInfoShown?'auto':'29px',fontSize:'12px',zIndex:groupStaffInfoShown ? 15 :3,position:'relative',padding:'0px 20px',minHeight:groupStaffInfoShown?'70px':''}}>
    <div style={{display:'flex',justifyContent:'space-between',marginTop:'3px'}}>
      <div >
        <span className='text_elip' style={{marginTop:'2px', }}>Note i BilletPro</span> 
         {/* { alertStaffinfo (theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'-18px',top:'4px'}} /> : ''} */}
       </div>
       <div> 
           {groupStaffInfoShown ? 
           <>
           {/* { staffText.length ?  */}
           <button    onClick={deleteAllStaffInfo} disabled={ true }           
           style={{textDecoration:'underline', cursor:'pointer',  }}>Slet
            </button> 
           
            <button  
            onClick={saveAllStaffInfo}
              disabled={ true} 
           style={{textDecoration:'underline',marginRight:'10px' }}>Gem
            </button> 
           
            </>
            : '' } 
           <button  style={{position:'absolute',right:'10px'}}
             onClick={(e) => groupStaffInfoClick(e)} 
            >
                <svg style={{ transform: groupStaffInfoShown?'rotate(180deg)' : ''}} xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5" fill="none">
                <path d="M8.52002 0.540237L5.21366 3.72414C4.82641 4.09705 4.21363 4.09705 3.82638 3.72414L0.52002 0.540238" stroke="#46484C" stroke-width="1.5"/>
</svg>
            </button>
                   
        </div>
          </div>
            {groupStaffInfoShown ?
             <div class="textarea" style={{margin:0,borderRdius:'4px',background: 'rgba(226, 226, 226, 0.80)'}} id='textarea' 
            onInput={(e) => handleAllStaffInfo(e)} 
            contentEditable="true">
              {
              // staffInfoSaved === true ? allStaffTextInput : 
              allBilletNotesSame === true ? chosenMovies[0].eventObject.StaffInfo : 'forskellige BilletPro noter'
              //  groupStaffText ? groupStaffText : groupwebInfoSaved === true ? groupStaffTextInput : groupStaffText 
               }
              </div> 
              : ''}
    </div>

 <hr style={{margin:0}} />
 <div style={{borderTop:'2px solid white',borderRadius:'4px',height:groupWebInfoShown?'auto':'29px',fontSize:'12px',zIndex:groupWebInfoShown?15:3,position:'relative',padding:'0px 20px',minHeight:groupWebInfoShown?'70px':''}}>
      <div style={{display:'flex',justifyContent:'space-between',}}>
        <div >
          <span className='text_elip'  style={{marginTop:'2px'}}>Note på webside</span>
         {/* { alertWebinfo (theEvent) === true ? <img src={ alertIcon} alt='alert-icon' style={{position:'absolute', right:'-18px',top:'4px'}} /> : '' }  */}
      </div>
      <div> 
           {groupWebInfoShown? 
           <>
           <button     onClick={deleteAllWebInfo}
           disabled={  true }                          
            style={{textDecoration:'underline',}}  >Slet</button> 
           <button 
          //  onClick={saveWebInfo} 
            disabled={(groupWebText || groupWebTextInput) == 'null' || ( groupWebTextInput.length < 1 )? true : false} 
            style={{textDecoration:'underline',marginRight:'10px'}}  >Gem</button> 
           </>
           : '' } 
           <button style={{position:'absolute',right:'10px'}}
             onClick={(e) => groupWebInfoClick(e)} 
            >
               <svg style={{ transform: groupWebInfoShown?'rotate(180deg)' : ''}}xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 15 9" >
                  <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g stroke="#46484c" strokeWidth="2.5">
                  <g>
                  <path d="M934 19.25L940.5 26.25 947 19.25" transform="translate(-1053 -509) translate(120 491)"/>
                   </g>
                   </g>
                   </g>
                </svg>  
            </button>
                   
        </div>
        </div>
        {groupWebInfoShown ?
          <div class="textarea" style={{margin:0,borderRdius:'4px',background: 'rgba(226, 226, 226, 0.80)'}} id='textarea'  onInput={(e) => handleGroupWebInfo(e)} contentEditable="true"> {
            allWebNotesSame === true ? chosenMovies[0].eventObject.WebInfo : 'forskellige webside noter'
            // groupWebText ? groupWebText : groupwebInfoSaved === true ? groupWebTextInput : groupWebText 
            }</div>
                  
                   : ''}
    </div>
          <hr  style={{marginTop:'0px',height:'2px'}}/>
 <div style={{display:'flex',zIndex: editChosen === true && modalShown === false ? 15: 2,position:'relative',justifyContent:'space-between',marginRight:'20px',marginLeft:'20px',marginBottom:'12px'}}>
       <button style={{width:'137px',color:'white',fontWeight:'bold',backgroundColor:'#982f2f',height:'40px',borderRadius:'4px'}} onClick={deleteTheEdit}>ANNULLER</button> 
       
       <button style={{width:'86px',fontWeight:'bold',backgroundColor:'#982f2f',height:'40px',color:'white',borderRadius:'4px'}} 
       onClick={saveTheEdit}>GEM</button>
    </div>
    </div>
   
        <EditChosenBox shown={editChosen} modalshown={modalShown}/>
    </section>
        :
        <button style={{opacity: chosenMovies.length > 0 ? '' : '0.5'}} disabled={chosenMovies.length > 0 ? '' : 'disabled'} className='editBtn' onClick={handleEdit} > REDIGER </button>
   }
   </div>
   <div style={{marginLeft:'22px',display:'flex',justifyContent:'space-between',marginTop:'8px'}}>
     <button className='deleteBtn' style={{opacity: chosenMovies.length > 0 ? '' : '0.5',backgroundColor:'#982f2f',color:'white',padding:'0px 30px'}} onClick={deleteGhostEvent}  disabled={chosenMovies.length > 0 ? '' : 'disabled'}> ANNULLER</button>  
     <button className='deleteBtn' style={{opacity: chosenMovies.length > 0 ? '' : '0.5',backgroundColor:'#982f2f',color:'white',padding:'0px 30px'}} onClick={saveChosenInSystem} disabled={chosenMovies.length > 0 ? '' : 'disabled'}>  GEM </button>
   </div>
  
    
</div>

                </div>
                </div>
                <div style={{display:'flex',flexDirection:'column',position:document.getElementById('main-frame')?.clientWidth < 1500 ? 'absolute' : '',top:'200px'}}>
                  <div>
                  <button className='saveBtn' onClick={saveAllInSystem}>GEM ALLE  I BILLETSYSTEM </button>
                  <button className='saveBtn' onClick={deleteAllInSystem}>ANNULLER ALLE</button>
                  </div>
                  <p className='info-text-program'>Gælder samtlige programlagte film og ikke kun det valgte datospænd</p>
                </div>
                </div>
              
        <GroupEditModal
        shown={modalShown}  data={grpEditArr} all_events={copied_events}
        close={() => {
          toggleModal(false);
        }}
      >
      </GroupEditModal>
      

<div  style={{display:'flex', justifyContent:'space-between',marginRight:'4px',
 // width:'1693px'
  }}>



  <div style={{display:'flex',position:'relative',right:'0'}}>
    <button className='markAllBtn' onClick={handleSelectAll}>Marker alle forestillinger</button>
 
  </div>
</div>


{ showErrorModal === true ? 
<ErrorModal shown={showErrorModal} errorStatus={errorStatus} errorType={errorType}
 errorNo={errorNo} errorText={errorText}/>
: ''}

   
 

{error ? <p style={{textAlign:'center'}}>kunne ikke vise forestillinger... </p> : 

<div style={{marginTop:document.getElementById('main-frame')?.clientWidth < 1500 ? '80px' : ''}}>
  { isloading == true && orgSelect? <ScaleLoader color="#982f2f" loading={isloading} height={100}  cssOverride={override}/> 
 :   number_of_days_array.map((item,index) => (
      <ProgramTable show_index={index}  eventsEdit={eventsEdit} allMovies={allMovies}  days={item} allEvents={allEvents} date_length= {number_of_days_array.length} numberOfSal={numberOfSal} modalShown={modalShown} isloading={isloading} 
       newDraggedFilm={newDraggedFilm}  filmWidth={filmWidth}
       daysEvent={ all_days_events.filter(e => moment(e.start).format('DD-MM-YYYY') == moment(item).format('DD-MM-YYYY')) } chosenMovies={chosenMovies} setchosenMovies={setchosenMovies} last_end_time={last_end_time} first_start_time={first_start_time} hasProgram={updateProgram} showPrice={showPrice} showForstype={showForstype} showPrimaryTkt={showPrimaryTkt} showStartEndtime={showStartEndtime}
      showInternetOrder={showInternetOrder} showInternetVis={showInternetVis}
      showInternetSalg={showInternetSalg} />
      )
     )
        }        

    </div>
              }

           </div>

        <div className='programContainer_aside'  style={{right:showFilm === true ? '350px' : ''}}
         onClick={document.getElementById('main-frame')?.clientWidth > 2000  ? '': showFilm === true ? '': handleShowFilm}
        >
             
            

  { 
     showFilm === true || document.getElementById('main-frame')?.clientWidth > 2000  ? 
        <section className='chooseFilmContainer' style={{position:'sticky',right:'350px',height:'100vh',top:'-70px',width:document.getElementById('main-frame')?.clientWidth > 2000 ? '' : '412px',border:document.getElementById('main-frame')?.clientWidth > 2000 ? '' : '1px solid #dee0e3'}}>
            <div id='t'  style={{display: showFilm || document.getElementById('main-frame')?.clientWidth > 2000  ? 'grid' : 'none', gridTemplateColumns: showFilm || document.getElementById('main-frame')?.clientWidth > 2000  ? '1fr 1fr' : '',marginTop:'1px',width:document.getElementById('main-frame')?.clientWidth > 2000 ? '' :'400px',position:'sticky',backgroundColor:'white',height:'105vh'}}  >
              {  document.getElementById('main-frame')?.clientWidth > 2000  ? '' :
                <aside   className='programContainer_aside' onClick={showFilm === true ? handleShowFilm : ''} >
                 <p className='choose' ></p>
                 <p className='film'></p>
                 <div className='vector'></div>
                 <div  style={{marginTop:'46vh',transform:'rotate(180deg)',marginRight:'12px'}} >
                    <img src={doublearrow} alt="" />
                 </div>
               
               </aside> 
               }
                <div style={{ width:'338px',paddingLeft:'30px',paddingTop:'50px',border:document.getElementById('main-frame')?.clientWidth > 2000 ? '1px solid #dee0e3' : ''}}>
                  {document.getElementById('main-frame')?.clientWidth > 2000  ? '' : 
                  <button style={{float:'right',border:'none', background:'none',marginTop:'20px'}} 
                   onClick={handleShowFilm}
                  >
                  <img src={close} alt='close'/> </button>
                  }
                  <br />
                  <br />
                  <br />
                <p className='choose_film' >Vælg film</p>
               
                <div style={{position:'relative',marginTop:'25px'}}>
                <input  className='search_film' placeholder='Søg efter film'  value={q}
                            onChange={(e) => setQ(e.target.value)}/> 

                  <span style={{position:'absolute', top:'7px',left:'10px'}}>
                  <img src={searchIcon} alt='search' height='20px'/></span>

                </div>

                <label htmlFor="" style={{margin:'20px 6px',display:'flex',position:'relative'}}>
                <input style= {{outline:searchPrecise ? '1px solid grey' : ''}}type='checkbox' checked={searchPrecise} onChange={handlePreciseSearch}/> 
                <span style={{color:'#46484c',position:'absolute',top:'-6px',left:'25px'}}>Slå søgning fra, indtast eksakt titel</span> 
                </label>
                
                  <label htmlFor="" style={{margin:'20px 6px',display:'flex',position:'relative'}}>
                <input style= {{outline:searchOwnOnly ? '1px solid grey' : ''}}type='checkbox' checked={searchOwnOnly} onChange={handleOwnSearchOnly}/> 
                <span style={{color:'#46484c',position:'absolute',top:'-6px',left:'25px'}}>Søg kun i egne film</span> 
                </label>
              
               
                <div className='image_container'>
                   {search(toFindDuplicates(data)).filter((a,b) => { return a.name !== b.name}).map((movie,i) => (
                     <div draggable onDragEnd={(e) => imgDragEnd(e)}  className='imgCont'  onDragStart=   {(e) => handleOnDrag(e,movie.name,movie)} >
                    <img   src={`https://ebillet.dk/poster/`+movie.poster.large} id={i} name={movie.name} duration={movie.length} movieno={movie.No} alt={movie.name} width='125px' height='185px' />  
                    <span className='tooltiptext'>{movie.name}</span>                      
                    </div>
                    ))}               
                </div> 
     
            </div>
          </div>
          </section>
           :  <aside   
                  style={{position:'sticky',top:'15%'}}
               >
                 <p className='choose' >Vælg</p>
                 <p className='film'>film</p>
                 <div className='vector'></div>
                 <div className='doubleArrows' style={{marginTop:'30vh'}}  >
                    <img src={doublearrow} alt="" />
                 </div>
               
               </aside> 
               }
               </div>
    
          </section>
       
      </main>
  )
}

export default Program